// This file is auto-generated by @hey-api/openapi-ts

import type { CancelablePromise } from './core/CancelablePromise';
import { OpenAPI } from './core/OpenAPI';
import { request as __request } from './core/request';
import type { $OpenApiTs } from './models';

export class NotificationsService {
  /**
   * Save a subscription if not saved yet
   * @returns any
   * @throws ApiError
   */
  public static saveSubscription(
    data: $OpenApiTs['/api/notifications/subscriptions']['post']['req'],
  ): CancelablePromise<$OpenApiTs['/api/notifications/subscriptions']['post']['res'][201]> {
    const { requestBody } = data;
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/notifications/subscriptions',
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * Get subscriptions list
   * @returns SubscriptionsListDto
   * @throws ApiError
   */
  public static getSubscriptions(): CancelablePromise<
    $OpenApiTs['/api/notifications/subscriptions']['get']['res'][200]
  > {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/notifications/subscriptions',
    });
  }

  /**
   * Delete subscription
   * @returns any
   * @throws ApiError
   */
  public static deleteSubscription(
    data: $OpenApiTs['/api/notifications/subscriptions/{sid}']['delete']['req'],
  ): CancelablePromise<$OpenApiTs['/api/notifications/subscriptions/{sid}']['delete']['res'][200]> {
    const { sid } = data;
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/api/notifications/subscriptions/{sid}',
      path: {
        sid,
      },
    });
  }

  /**
   * Get all notifications
   * @returns any
   * @throws ApiError
   */
  public static getAllNotifications(): CancelablePromise<$OpenApiTs['/api/notifications']['get']['res'][200]> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/notifications',
    });
  }

  /**
   * Get notification settings
   * @returns any
   * @throws ApiError
   */
  public static getNotificationSettings(): CancelablePromise<
    $OpenApiTs['/api/notifications/settings']['get']['res'][200]
  > {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/notifications/settings',
    });
  }

  /**
   * Set notification settings
   * @returns any
   * @throws ApiError
   */
  public static updateNotificationSettings(
    data: $OpenApiTs['/api/notifications/settings']['post']['req'],
  ): CancelablePromise<$OpenApiTs['/api/notifications/settings']['post']['res'][201]> {
    const { requestBody } = data;
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/notifications/settings',
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * Set all notifications read
   * @returns any
   * @throws ApiError
   */
  public static setAllNotificationsRead(): CancelablePromise<
    $OpenApiTs['/api/notifications/read']['post']['res'][201]
  > {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/notifications/read',
    });
  }

  /**
   * Set notification read
   * @returns any
   * @throws ApiError
   */
  public static setNotificationRead(
    data: $OpenApiTs['/api/notifications/read/{id}']['post']['req'],
  ): CancelablePromise<$OpenApiTs['/api/notifications/read/{id}']['post']['res'][201]> {
    const { id } = data;
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/notifications/read/{id}',
      path: {
        id,
      },
    });
  }

  /**
   * Unsubscribe
   * @returns any
   * @throws ApiError
   */
  public static unsubscribe(
    data: $OpenApiTs['/api/notifications/unsubscribe']['post']['req'],
  ): CancelablePromise<$OpenApiTs['/api/notifications/unsubscribe']['post']['res'][201]> {
    const { requestBody } = data;
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/notifications/unsubscribe',
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * Delete notification
   * @returns any
   * @throws ApiError
   */
  public static deleteNotification(
    data: $OpenApiTs['/api/notifications/{id}']['delete']['req'],
  ): CancelablePromise<$OpenApiTs['/api/notifications/{id}']['delete']['res'][200]> {
    const { id } = data;
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/api/notifications/{id}',
      path: {
        id,
      },
    });
  }
}

export class AuthService {
  /**
   * Get auth info
   * @returns UserDto
   * @throws ApiError
   */
  public static me(): CancelablePromise<$OpenApiTs['/api/auth/me']['get']['res'][200]> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/auth/me',
    });
  }

  /**
   * Get is logged in flag
   * @returns string
   * @throws ApiError
   */
  public static getUserId(): CancelablePromise<$OpenApiTs['/api/auth/userId']['get']['res'][200]> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/auth/userId',
    });
  }

  /**
   * Test JWT
   * @returns any
   * @throws ApiError
   */
  public static testJwt(): CancelablePromise<$OpenApiTs['/api/auth/test-jwt']['get']['res'][200]> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/auth/test-jwt',
    });
  }

  /**
   * Register
   * @returns any
   * @throws ApiError
   */
  public static register(
    data: $OpenApiTs['/api/auth/register']['post']['req'],
  ): CancelablePromise<$OpenApiTs['/api/auth/register']['post']['res'][201]> {
    const { requestBody } = data;
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/auth/register',
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * Confirm account
   * @returns any
   * @throws ApiError
   */
  public static confirm(
    data: $OpenApiTs['/api/auth/confirm']['get']['req'],
  ): CancelablePromise<$OpenApiTs['/api/auth/confirm']['get']['res'][200]> {
    const { code, email } = data;
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/auth/confirm',
      query: {
        code,
        email,
      },
    });
  }

  /**
   * Login
   * @returns any
   * @throws ApiError
   */
  public static login(
    data: $OpenApiTs['/api/auth/login']['post']['req'],
  ): CancelablePromise<$OpenApiTs['/api/auth/login']['post']['res'][201]> {
    const { requestBody } = data;
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/auth/login',
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * SSO Login
   * @returns any
   * @throws ApiError
   */
  public static ssoLogin(
    data: $OpenApiTs['/api/auth/sso/login']['post']['req'],
  ): CancelablePromise<$OpenApiTs['/api/auth/sso/login']['post']['res'][201]> {
    const { requestBody } = data;
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/auth/sso/login',
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * Recover password
   * @returns any
   * @throws ApiError
   */
  public static recover(
    data: $OpenApiTs['/api/auth/recover']['post']['req'],
  ): CancelablePromise<$OpenApiTs['/api/auth/recover']['post']['res'][201]> {
    const { requestBody } = data;
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/auth/recover',
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * Reset password
   * @returns any
   * @throws ApiError
   */
  public static resetPasswordCallback(
    data: $OpenApiTs['/api/auth/resetpassword']['get']['req'],
  ): CancelablePromise<$OpenApiTs['/api/auth/resetpassword']['get']['res'][200]> {
    const { email, code } = data;
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/auth/resetpassword',
      query: {
        email,
        code,
      },
    });
  }

  /**
   * Set password
   * @returns any
   * @throws ApiError
   */
  public static passwd(
    data: $OpenApiTs['/api/auth/passwd']['post']['req'],
  ): CancelablePromise<$OpenApiTs['/api/auth/passwd']['post']['res'][201]> {
    const { requestBody } = data;
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/auth/passwd',
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * Refresh JWT token
   * @returns any
   * @throws ApiError
   */
  public static refreshToken(): CancelablePromise<$OpenApiTs['/api/auth/refresh']['post']['res'][201]> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/auth/refresh',
    });
  }

  /**
   * Clean cookies
   * @returns any
   * @throws ApiError
   */
  public static logout(): CancelablePromise<$OpenApiTs['/api/auth/logout']['post']['res'][201]> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/auth/logout',
    });
  }

  /**
   * Check phone number
   * @returns any
   * @throws ApiError
   */
  public static checkPhoneNumber(
    data: $OpenApiTs['/api/auth/check-phone-number']['post']['req'],
  ): CancelablePromise<$OpenApiTs['/api/auth/check-phone-number']['post']['res'][201]> {
    const { requestBody } = data;
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/auth/check-phone-number',
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * Check email
   * @returns any
   * @throws ApiError
   */
  public static checkEmail(
    data: $OpenApiTs['/api/auth/check-email']['post']['req'],
  ): CancelablePromise<$OpenApiTs['/api/auth/check-email']['post']['res'][201]> {
    const { requestBody } = data;
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/auth/check-email',
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * Send OTP code
   * @returns any
   * @throws ApiError
   */
  public static sendOtpCode(): CancelablePromise<$OpenApiTs['/api/auth/send-otp-code']['post']['res'][201]> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/auth/send-otp-code',
    });
  }

  /**
   * Verify phone
   * @returns any
   * @throws ApiError
   */
  public static verifyPhone(): CancelablePromise<$OpenApiTs['/api/auth/verify-otp-code']['post']['res'][201]> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/auth/verify-otp-code',
    });
  }
}

export class WorkspacesService {
  /**
   * List all workspaces for the current user
   * @returns any
   * @throws ApiError
   */
  public static findAll(): CancelablePromise<$OpenApiTs['/api/workspaces']['get']['res'][200]> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/workspaces',
    });
  }

  /**
   * Create workspace
   * @returns any
   * @throws ApiError
   */
  public static createWorkspace(
    data: $OpenApiTs['/api/workspaces']['post']['req'],
  ): CancelablePromise<$OpenApiTs['/api/workspaces']['post']['res'][201]> {
    const { requestBody } = data;
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/workspaces',
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * Get workspace (for Admin)
   * @returns any
   * @throws ApiError
   */
  public static adminGetWorkspace(
    data: $OpenApiTs['/api/workspaces/admin/{id}']['get']['req'],
  ): CancelablePromise<$OpenApiTs['/api/workspaces/admin/{id}']['get']['res'][200]> {
    const { id } = data;
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/workspaces/admin/{id}',
      path: {
        id,
      },
    });
  }

  /**
   * Get workspace teams (for Admin)
   * @returns any
   * @throws ApiError
   */
  public static adminGetTeams(
    data: $OpenApiTs['/api/workspaces/admin/{id}/teams']['get']['req'],
  ): CancelablePromise<$OpenApiTs['/api/workspaces/admin/{id}/teams']['get']['res'][200]> {
    const { id } = data;
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/workspaces/admin/{id}/teams',
      path: {
        id,
      },
    });
  }

  /**
   * Check if the given slug is available (with except the given workspace)
   * @returns any
   * @throws ApiError
   */
  public static isWorkspaceSlugAvailable(
    data: $OpenApiTs['/api/workspaces/is-available/{oid}/{wsid}/{wsSlug}']['get']['req'],
  ): CancelablePromise<$OpenApiTs['/api/workspaces/is-available/{oid}/{wsid}/{wsSlug}']['get']['res'][200]> {
    const { oid, wsid, wsSlug } = data;
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/workspaces/is-available/{oid}/{wsid}/{wsSlug}',
      path: {
        oid,
        wsid,
        wsSlug,
      },
    });
  }

  /**
   * Check if the given slug is available
   * @returns any
   * @throws ApiError
   */
  public static isSlugAvailable(
    data: $OpenApiTs['/api/workspaces/is-available/{oid}/{wsSlug}']['get']['req'],
  ): CancelablePromise<$OpenApiTs['/api/workspaces/is-available/{oid}/{wsSlug}']['get']['res'][200]> {
    const { wsSlug, oid } = data;
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/workspaces/is-available/{oid}/{wsSlug}',
      path: {
        wsSlug,
        oid,
      },
    });
  }

  /**
   * Delete workspace
   * @returns any
   * @throws ApiError
   */
  public static deleteWs(
    data: $OpenApiTs['/api/workspaces/{wsid}']['delete']['req'],
  ): CancelablePromise<$OpenApiTs['/api/workspaces/{wsid}']['delete']['res'][200]> {
    const { wsid } = data;
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/api/workspaces/{wsid}',
      path: {
        wsid,
      },
    });
  }

  /**
   * Update workspace
   * @returns any
   * @throws ApiError
   */
  public static updateWorkspace(
    data: $OpenApiTs['/api/workspaces/{wsid}']['post']['req'],
  ): CancelablePromise<$OpenApiTs['/api/workspaces/{wsid}']['post']['res'][201]> {
    const { wsid, requestBody } = data;
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/workspaces/{wsid}',
      path: {
        wsid,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * Request workspace access
   * @returns any
   * @throws ApiError
   */
  public static requestWsAccess(
    data: $OpenApiTs['/api/workspaces/{orgSlug}/{wsSlug}/request-access']['post']['req'],
  ): CancelablePromise<$OpenApiTs['/api/workspaces/{orgSlug}/{wsSlug}/request-access']['post']['res'][201]> {
    const { orgSlug, wsSlug } = data;
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/workspaces/{orgSlug}/{wsSlug}/request-access',
      path: {
        orgSlug,
        wsSlug,
      },
    });
  }

  /**
   * Get workspace teams
   * @returns any
   * @throws ApiError
   */
  public static getTeams(
    data: $OpenApiTs['/api/workspaces/{orgSlug}/{wsSlug}/teams']['get']['req'],
  ): CancelablePromise<$OpenApiTs['/api/workspaces/{orgSlug}/{wsSlug}/teams']['get']['res'][200]> {
    const { orgSlug, wsSlug } = data;
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/workspaces/{orgSlug}/{wsSlug}/teams',
      path: {
        orgSlug,
        wsSlug,
      },
    });
  }

  /**
   * Update workspace by adding a team
   * @returns any
   * @throws ApiError
   */
  public static updateWorkspaceByAddingTeam(
    data: $OpenApiTs['/api/workspaces/{orgSlug}/{wsSlug}/teams']['post']['req'],
  ): CancelablePromise<$OpenApiTs['/api/workspaces/{orgSlug}/{wsSlug}/teams']['post']['res'][201]> {
    const { orgSlug, wsSlug, requestBody } = data;
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/workspaces/{orgSlug}/{wsSlug}/teams',
      path: {
        orgSlug,
        wsSlug,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * Get available teams for workspace
   * @returns any
   * @throws ApiError
   */
  public static getAvailableTeams(
    data: $OpenApiTs['/api/workspaces/{orgSlug}/{wsSlug}/teams/available']['get']['req'],
  ): CancelablePromise<$OpenApiTs['/api/workspaces/{orgSlug}/{wsSlug}/teams/available']['get']['res'][200]> {
    const { orgSlug, wsSlug } = data;
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/workspaces/{orgSlug}/{wsSlug}/teams/available',
      path: {
        orgSlug,
        wsSlug,
      },
    });
  }

  /**
   * Update workspace by removing a team
   * @returns any
   * @throws ApiError
   */
  public static updateWorkspaceByRemovingTeam(
    data: $OpenApiTs['/api/workspaces/{orgSlug}/{wsSlug}/teams/{teamId}']['delete']['req'],
  ): CancelablePromise<$OpenApiTs['/api/workspaces/{orgSlug}/{wsSlug}/teams/{teamId}']['delete']['res'][200]> {
    const { orgSlug, wsSlug, teamId } = data;
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/api/workspaces/{orgSlug}/{wsSlug}/teams/{teamId}',
      path: {
        orgSlug,
        wsSlug,
        teamId,
      },
    });
  }

  /**
   * Get workspace
   * @returns any
   * @throws ApiError
   */
  public static getWorkspaceBySlugs(
    data: $OpenApiTs['/api/workspaces/{orgSlug}/{wsSlug}']['get']['req'],
  ): CancelablePromise<$OpenApiTs['/api/workspaces/{orgSlug}/{wsSlug}']['get']['res'][200]> {
    const { orgSlug, wsSlug } = data;
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/workspaces/{orgSlug}/{wsSlug}',
      path: {
        orgSlug,
        wsSlug,
      },
    });
  }
}

export class OrganizationsService {
  /**
   * Create a new organizations with the current user as the owner
   * @returns any
   * @throws ApiError
   */
  public static create(
    data: $OpenApiTs['/api/organizations']['post']['req'],
  ): CancelablePromise<$OpenApiTs['/api/organizations']['post']['res'][201]> {
    const { requestBody } = data;
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/organizations',
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * List all organizations for the current user
   * @returns any
   * @throws ApiError
   */
  public static findAll(): CancelablePromise<$OpenApiTs['/api/organizations']['get']['res'][200]> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/organizations',
    });
  }

  /**
   * Get all organization jobs list
   * @returns any
   * @throws ApiError
   */
  public static getAllOrganizationJobs(
    data: $OpenApiTs['/api/organizations/{oid}/jobs']['get']['req'],
  ): CancelablePromise<$OpenApiTs['/api/organizations/{oid}/jobs']['get']['res'][200]> {
    const { oid, statuses, pageNo, pageSize, orderBy, orderType, search, jobsFrom, jobsTo } = data;
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/organizations/{oid}/jobs',
      path: {
        oid,
      },
      query: {
        statuses,
        pageNo,
        pageSize,
        orderBy,
        orderType,
        search,
        jobsFrom,
        jobsTo,
      },
    });
  }

  /**
   * Shows the details for a particular organization
   * @returns any
   * @throws ApiError
   */
  public static findOne(
    data: $OpenApiTs['/api/organizations/{oid}']['get']['req'],
  ): CancelablePromise<$OpenApiTs['/api/organizations/{oid}']['get']['res'][200]> {
    const { oid } = data;
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/organizations/{oid}',
      path: {
        oid,
      },
    });
  }

  /**
   * Updates an organization
   * @returns any
   * @throws ApiError
   */
  public static update(
    data: $OpenApiTs['/api/organizations/{oid}']['patch']['req'],
  ): CancelablePromise<$OpenApiTs['/api/organizations/{oid}']['patch']['res'][200]> {
    const { oid, requestBody } = data;
    return __request(OpenAPI, {
      method: 'PATCH',
      url: '/api/organizations/{oid}',
      path: {
        oid,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * Deletes an organization
   * @returns any
   * @throws ApiError
   */
  public static remove(
    data: $OpenApiTs['/api/organizations/{oid}']['delete']['req'],
  ): CancelablePromise<$OpenApiTs['/api/organizations/{oid}']['delete']['res'][200]> {
    const { oid } = data;
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/api/organizations/{oid}',
      path: {
        oid,
      },
    });
  }

  /**
   * Disable user for organization
   * @returns any
   * @throws ApiError
   */
  public static disableUser(
    data: $OpenApiTs['/api/organizations/{oid}/disable-user/{userId}']['patch']['req'],
  ): CancelablePromise<$OpenApiTs['/api/organizations/{oid}/disable-user/{userId}']['patch']['res'][200]> {
    const { oid, userId } = data;
    return __request(OpenAPI, {
      method: 'PATCH',
      url: '/api/organizations/{oid}/disable-user/{userId}',
      path: {
        oid,
        userId,
      },
    });
  }

  /**
   * Delete user from organization
   * @returns any
   * @throws ApiError
   */
  public static deleteUser(
    data: $OpenApiTs['/api/organizations/{oid}/user/{userId}']['delete']['req'],
  ): CancelablePromise<$OpenApiTs['/api/organizations/{oid}/user/{userId}']['delete']['res'][200]> {
    const { oid, userId } = data;
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/api/organizations/{oid}/user/{userId}',
      path: {
        oid,
        userId,
      },
    });
  }

  /**
   * Get upload image params
   * @returns any
   * @throws ApiError
   */
  public static signedUpload(
    data: $OpenApiTs['/api/organizations/{oid}/signed-upload']['get']['req'],
  ): CancelablePromise<$OpenApiTs['/api/organizations/{oid}/signed-upload']['get']['res'][200]> {
    const { oid } = data;
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/organizations/{oid}/signed-upload',
      path: {
        oid,
      },
    });
  }

  /**
   * Deletes an organization image
   * @returns any
   * @throws ApiError
   */
  public static removeImage(
    data: $OpenApiTs['/api/organizations/{oid}/image']['delete']['req'],
  ): CancelablePromise<$OpenApiTs['/api/organizations/{oid}/image']['delete']['res'][200]> {
    const { oid } = data;
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/api/organizations/{oid}/image',
      path: {
        oid,
      },
    });
  }

  /**
   * Check if the given slug is available (with except the given workspace)
   * @returns any
   * @throws ApiError
   */
  public static isOrganizationSlugAvailable(
    data: $OpenApiTs['/api/organizations/is-available/{oid}/{slug}']['get']['req'],
  ): CancelablePromise<$OpenApiTs['/api/organizations/is-available/{oid}/{slug}']['get']['res'][200]> {
    const { oid, slug } = data;
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/organizations/is-available/{oid}/{slug}',
      path: {
        oid,
        slug,
      },
    });
  }

  /**
   * Check if the given slug is available
   * @returns any
   * @throws ApiError
   */
  public static isSlugAvailable(
    data: $OpenApiTs['/api/organizations/is-available/{slug}']['get']['req'],
  ): CancelablePromise<$OpenApiTs['/api/organizations/is-available/{slug}']['get']['res'][200]> {
    const { slug } = data;
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/organizations/is-available/{slug}',
      path: {
        slug,
      },
    });
  }

  /**
   * Get Organization members list
   * @returns any
   * @throws ApiError
   */
  public static getOrgMembers(
    data: $OpenApiTs['/api/organizations/{oid}/members']['get']['req'],
  ): CancelablePromise<$OpenApiTs['/api/organizations/{oid}/members']['get']['res'][200]> {
    const { oid, pageNo, pageSize, orderBy, orderType, search, teamsSlugFilter } = data;
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/organizations/{oid}/members',
      path: {
        oid,
      },
      query: {
        pageNo,
        pageSize,
        orderBy,
        orderType,
        search,
        teamsSlugFilter,
      },
    });
  }

  /**
   * Get Organization members list for workspace
   * @returns any
   * @throws ApiError
   */
  public static getWorkspaceMembers(
    data: $OpenApiTs['/api/organizations/{oid}/{workspaceId}/members']['get']['req'],
  ): CancelablePromise<$OpenApiTs['/api/organizations/{oid}/{workspaceId}/members']['get']['res'][200]> {
    const { oid, workspaceId, search, teamsSlugFilter } = data;
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/organizations/{oid}/{workspaceId}/members',
      path: {
        oid,
        workspaceId,
      },
      query: {
        search,
        teamsSlugFilter,
      },
    });
  }

  /**
   * Set members can manage layouts flag
   * @returns any
   * @throws ApiError
   */
  public static setMemberCanManageLayoutFlag(
    data: $OpenApiTs['/api/organizations/{oid}/members/{memberId}/can-manage-layouts']['post']['req'],
  ): CancelablePromise<
    $OpenApiTs['/api/organizations/{oid}/members/{memberId}/can-manage-layouts']['post']['res'][201]
  > {
    const { oid, memberId, requestBody } = data;
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/organizations/{oid}/members/{memberId}/can-manage-layouts',
      path: {
        oid,
        memberId,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * Get Organization members list for reports
   * @returns any
   * @throws ApiError
   */
  public static getOrgMemberReports(
    data: $OpenApiTs['/api/organizations/{oid}/member-reports']['get']['req'],
  ): CancelablePromise<$OpenApiTs['/api/organizations/{oid}/member-reports']['get']['res'][200]> {
    const { oid, pageNo, pageSize, orderBy, orderType, search, jobsFrom, jobsTo } = data;
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/organizations/{oid}/member-reports',
      path: {
        oid,
      },
      query: {
        pageNo,
        pageSize,
        orderBy,
        orderType,
        search,
        jobsFrom,
        jobsTo,
      },
    });
  }

  /**
   * Change member concurrentJobsLimit
   * @returns successResponse
   * @throws ApiError
   */
  public static changeConcurrentJobsLimit(
    data: $OpenApiTs['/api/organizations/{oid}/members/{memberId}/concurrentJobsLimit']['post']['req'],
  ): CancelablePromise<
    $OpenApiTs['/api/organizations/{oid}/members/{memberId}/concurrentJobsLimit']['post']['res'][200]
  > {
    const { oid, memberId, requestBody } = data;
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/organizations/{oid}/members/{memberId}/concurrentJobsLimit',
      path: {
        oid,
        memberId,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * Get Organization workspaces list with statuses
   * @returns any
   * @throws ApiError
   */
  public static getOrgWorkspaces(
    data: $OpenApiTs['/api/organizations/{oid}/workspaces/statuses']['get']['req'],
  ): CancelablePromise<$OpenApiTs['/api/organizations/{oid}/workspaces/statuses']['get']['res'][200]> {
    const { oid } = data;
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/organizations/{oid}/workspaces/statuses',
      path: {
        oid,
      },
    });
  }

  /**
   * Get organization invitations list
   * @returns any
   * @throws ApiError
   */
  public static getWsInvitations(
    data: $OpenApiTs['/api/organizations/{oid}/invitations']['get']['req'],
  ): CancelablePromise<$OpenApiTs['/api/organizations/{oid}/invitations']['get']['res'][200]> {
    const { oid, search } = data;
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/organizations/{oid}/invitations',
      path: {
        oid,
      },
      query: {
        search,
      },
    });
  }

  /**
   * Create organization invitation
   * @returns any
   * @throws ApiError
   */
  public static createInvitation(
    data: $OpenApiTs['/api/organizations/{oid}/invitations']['post']['req'],
  ): CancelablePromise<$OpenApiTs['/api/organizations/{oid}/invitations']['post']['res'][201]> {
    const { oid, requestBody } = data;
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/organizations/{oid}/invitations',
      path: {
        oid,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * Delete organization invitation
   * @returns any
   * @throws ApiError
   */
  public static deleteWsInvitation(
    data: $OpenApiTs['/api/organizations/{oid}/invitations/{iid}']['delete']['req'],
  ): CancelablePromise<$OpenApiTs['/api/organizations/{oid}/invitations/{iid}']['delete']['res'][200]> {
    const { oid, iid } = data;
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/api/organizations/{oid}/invitations/{iid}',
      path: {
        oid,
        iid,
      },
    });
  }

  /**
   * Create organization invitations by bulk
   * @returns any
   * @throws ApiError
   */
  public static createInvitations(
    data: $OpenApiTs['/api/organizations/{oid}/invitations/bulk']['post']['req'],
  ): CancelablePromise<$OpenApiTs['/api/organizations/{oid}/invitations/bulk']['post']['res'][201]> {
    const { oid, requestBody } = data;
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/organizations/{oid}/invitations/bulk',
      path: {
        oid,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * Get Organization repositories
   * @returns any
   * @throws ApiError
   */
  public static getOrgReposList(
    data: $OpenApiTs['/api/organizations/{oid}/repositories']['get']['req'],
  ): CancelablePromise<$OpenApiTs['/api/organizations/{oid}/repositories']['get']['res'][200]> {
    const { oid } = data;
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/organizations/{oid}/repositories',
      path: {
        oid,
      },
    });
  }

  /**
   * Get Organization repositories list with statuses
   * @returns any
   * @throws ApiError
   */
  public static getOrgRepos(
    data: $OpenApiTs['/api/organizations/{oid}/repositories/statuses']['get']['req'],
  ): CancelablePromise<$OpenApiTs['/api/organizations/{oid}/repositories/statuses']['get']['res'][200]> {
    const { oid, pageNo, pageSize, orderBy, orderType, search, from, to } = data;
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/organizations/{oid}/repositories/statuses',
      path: {
        oid,
      },
      query: {
        pageNo,
        pageSize,
        orderBy,
        orderType,
        search,
        from,
        to,
      },
    });
  }

  /**
   * Get Organization teams list
   * @returns any
   * @throws ApiError
   */
  public static getOrgTeams(
    data: $OpenApiTs['/api/organizations/{oid}/teams']['get']['req'],
  ): CancelablePromise<$OpenApiTs['/api/organizations/{oid}/teams']['get']['res'][200]> {
    const { oid } = data;
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/organizations/{oid}/teams',
      path: {
        oid,
      },
    });
  }

  /**
   * Get Organization entities list for search
   * @returns SearchResponseDto
   * @throws ApiError
   */
  public static search(
    data: $OpenApiTs['/api/organizations/{oid}/search/{search}']['get']['req'],
  ): CancelablePromise<$OpenApiTs['/api/organizations/{oid}/search/{search}']['get']['res'][200]> {
    const { oid, search } = data;
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/organizations/{oid}/search/{search}',
      path: {
        oid,
        search,
      },
    });
  }

  /**
   * Get value of org feature flag which is allowing backup recording
   * @returns any
   * @throws ApiError
   */
  public static getAsOneBackupRecordingAllowedFlag(
    data: $OpenApiTs['/api/organizations/{oid}/asone-backup-recording-allowed']['get']['req'],
  ): CancelablePromise<$OpenApiTs['/api/organizations/{oid}/asone-backup-recording-allowed']['get']['res'][200]> {
    const { oid } = data;
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/organizations/{oid}/asone-backup-recording-allowed',
      path: {
        oid,
      },
    });
  }

  /**
   * Set subscription backup recording flag globally (updates all licenses)
   * @returns any
   * @throws ApiError
   */
  public static setAsOneBackupRecordingAllowedFlag(
    data: $OpenApiTs['/api/organizations/{oid}/{subscriptionId}/global-asone-backup-recording-flag']['post']['req'],
  ): CancelablePromise<
    $OpenApiTs['/api/organizations/{oid}/{subscriptionId}/global-asone-backup-recording-flag']['post']['res'][201]
  > {
    const { oid, subscriptionId, requestBody } = data;
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/organizations/{oid}/{subscriptionId}/global-asone-backup-recording-flag',
      path: {
        oid,
        subscriptionId,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * Set asOneBackupRecordingTermsAccepted flag
   * @returns any
   * @throws ApiError
   */
  public static asOneBackupRecordingAcceptTerms(
    data: $OpenApiTs['/api/organizations/{oid}/asone-backup-recording-accept-terms']['post']['req'],
  ): CancelablePromise<$OpenApiTs['/api/organizations/{oid}/asone-backup-recording-accept-terms']['post']['res'][201]> {
    const { oid } = data;
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/organizations/{oid}/asone-backup-recording-accept-terms',
      path: {
        oid,
      },
    });
  }
}

export class JobsService {
  /**
   * @returns any
   * @throws ApiError
   */
  public static getJobQuarantineStatus(
    data: $OpenApiTs['/api/jobs/{id}/quarantined']['get']['req'],
  ): CancelablePromise<$OpenApiTs['/api/jobs/{id}/quarantined']['get']['res'][200]> {
    const { id } = data;
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/jobs/{id}/quarantined',
      path: {
        id,
      },
    });
  }

  /**
   * @returns any
   * @throws ApiError
   */
  public static getJobLink(
    data: $OpenApiTs['/api/jobs/{id}/details-link']['get']['req'],
  ): CancelablePromise<$OpenApiTs['/api/jobs/{id}/details-link']['get']['res'][200]> {
    const { id } = data;
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/jobs/{id}/details-link',
      path: {
        id,
      },
    });
  }

  /**
   * Get jobs TranscriptUnlockType can be changed status (for admin)
   * @returns any
   * @throws ApiError
   */
  public static adminGetJobCanChangeTranscriptUnlockType(
    data: $OpenApiTs['/api/admin/jobs/{id}/can-change-transcript-unlock-type']['get']['req'],
  ): CancelablePromise<$OpenApiTs['/api/admin/jobs/{id}/can-change-transcript-unlock-type']['get']['res'][200]> {
    const { id } = data;
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/admin/jobs/{id}/can-change-transcript-unlock-type',
      path: {
        id,
      },
    });
  }

  /**
   * Get jobs backup files list (for admin)
   * @returns any
   * @throws ApiError
   */
  public static adminGetJobBackupFiles(
    data: $OpenApiTs['/api/admin/jobs/{id}/backup-files']['get']['req'],
  ): CancelablePromise<$OpenApiTs['/api/admin/jobs/{id}/backup-files']['get']['res'][200]> {
    const { id } = data;
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/admin/jobs/{id}/backup-files',
      path: {
        id,
      },
    });
  }

  /**
   * Get mixdown processing status (for admin)
   * @returns any
   * @throws ApiError
   */
  public static adminMixdownJobBackupFiles(
    data: $OpenApiTs['/api/admin/jobs/{id}/backup-files/mix-down']['get']['req'],
  ): CancelablePromise<$OpenApiTs['/api/admin/jobs/{id}/backup-files/mix-down']['get']['res'][200]> {
    const { id } = data;
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/admin/jobs/{id}/backup-files/mix-down',
      path: {
        id,
      },
    });
  }

  /**
   * Mixdown and upload backup files (for admin)
   * @returns any
   * @throws ApiError
   */
  public static adminGetMixdownJobBackupFilesStatus(
    data: $OpenApiTs['/api/admin/jobs/{mixdownId}/backup-files/mix-down/status']['get']['req'],
  ): CancelablePromise<$OpenApiTs['/api/admin/jobs/{mixdownId}/backup-files/mix-down/status']['get']['res'][200]> {
    const { mixdownId } = data;
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/admin/jobs/{mixdownId}/backup-files/mix-down/status',
      path: {
        mixdownId,
      },
    });
  }

  /**
   * Get jobs TranscriptUnlockType can be changed status
   * @returns any
   * @throws ApiError
   */
  public static getJobCanChangeTranscriptUnlockType(
    data: $OpenApiTs['/api/{wsid}/jobs/{id}/can-change-transcript-unlock-type']['get']['req'],
  ): CancelablePromise<$OpenApiTs['/api/{wsid}/jobs/{id}/can-change-transcript-unlock-type']['get']['res'][200]> {
    const { wsid, id } = data;
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/{wsid}/jobs/{id}/can-change-transcript-unlock-type',
      path: {
        wsid,
        id,
      },
    });
  }

  /**
   * Update directly job status for cypress tests
   * @returns any
   * @throws ApiError
   */
  public static updateJobStatus(
    data: $OpenApiTs['/api/jobs/{id}/status/{status}']['patch']['req'],
  ): CancelablePromise<$OpenApiTs['/api/jobs/{id}/status/{status}']['patch']['res'][200]> {
    const { id, status } = data;
    return __request(OpenAPI, {
      method: 'PATCH',
      url: '/api/jobs/{id}/status/{status}',
      path: {
        id,
        status,
      },
    });
  }

  /**
   * Get jobs list
   * @returns any
   * @throws ApiError
   */
  public static getWsJobs(
    data: $OpenApiTs['/api/{wsid}/jobs']['get']['req'],
  ): CancelablePromise<$OpenApiTs['/api/{wsid}/jobs']['get']['res'][200]> {
    const { wsid, pageNo, pageSize, orderBy, orderType, search, status, from, to } = data;
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/{wsid}/jobs',
      path: {
        wsid,
      },
      query: {
        pageNo,
        pageSize,
        orderBy,
        orderType,
        search,
        status,
        from,
        to,
      },
    });
  }

  /**
   * Create or edit WS job
   * @returns any
   * @throws ApiError
   */
  public static createOrEditWsJob(
    data: $OpenApiTs['/api/{wsid}/jobs']['post']['req'],
  ): CancelablePromise<$OpenApiTs['/api/{wsid}/jobs']['post']['res'][201]> {
    const { wsid, requestBody } = data;
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/{wsid}/jobs',
      path: {
        wsid,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * Delete jobs
   * @returns any
   * @throws ApiError
   */
  public static softDeleteJobs(
    data: $OpenApiTs['/api/{wsid}/jobs']['delete']['req'],
  ): CancelablePromise<$OpenApiTs['/api/{wsid}/jobs']['delete']['res'][200]> {
    const { wsid, requestBody } = data;
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/api/{wsid}/jobs',
      path: {
        wsid,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * Get jobs list for repository
   * @returns any
   * @throws ApiError
   */
  public static getRepoJobs(
    data: $OpenApiTs['/api/repository/{repositoryId}/jobs']['get']['req'],
  ): CancelablePromise<$OpenApiTs['/api/repository/{repositoryId}/jobs']['get']['res'][200]> {
    const { repositoryId, pageNo, pageSize, orderBy, orderType, search } = data;
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/repository/{repositoryId}/jobs',
      path: {
        repositoryId,
      },
      query: {
        pageNo,
        pageSize,
        orderBy,
        orderType,
        search,
      },
    });
  }

  /**
   * Bulk create
   * @returns any
   * @throws ApiError
   */
  public static bulkCreateRepositoryJobs(
    data: $OpenApiTs['/api/repository/{repositoryId}/jobs/bulk']['post']['req'],
  ): CancelablePromise<$OpenApiTs['/api/repository/{repositoryId}/jobs/bulk']['post']['res'][201]> {
    const { repositoryId } = data;
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/repository/{repositoryId}/jobs/bulk',
      path: {
        repositoryId,
      },
    });
  }

  /**
   * Get my jobs list
   * @returns any
   * @throws ApiError
   */
  public static getMyJobs(
    data: $OpenApiTs['/api/{wsid}/jobs/my']['get']['req'],
  ): CancelablePromise<$OpenApiTs['/api/{wsid}/jobs/my']['get']['res'][200]> {
    const { wsid, pageNo, pageSize, orderBy, orderType, search, from, to } = data;
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/{wsid}/jobs/my',
      path: {
        wsid,
      },
      query: {
        pageNo,
        pageSize,
        orderBy,
        orderType,
        search,
        from,
        to,
      },
    });
  }

  /**
   * Get job by ID
   * @returns any
   * @throws ApiError
   */
  public static getJobById(
    data: $OpenApiTs['/api/{wsid}/jobs/{id}']['get']['req'],
  ): CancelablePromise<$OpenApiTs['/api/{wsid}/jobs/{id}']['get']['res'][200]> {
    const { id, wsid } = data;
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/{wsid}/jobs/{id}',
      path: {
        id,
        wsid,
      },
    });
  }

  /**
   * Delete job
   * @returns any
   * @throws ApiError
   */
  public static softDeleteWsJob(
    data: $OpenApiTs['/api/{wsid}/jobs/{id}']['delete']['req'],
  ): CancelablePromise<$OpenApiTs['/api/{wsid}/jobs/{id}']['delete']['res'][200]> {
    const { wsid, id } = data;
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/api/{wsid}/jobs/{id}',
      path: {
        wsid,
        id,
      },
    });
  }

  /**
   * Download Repository ZIP from a job
   * @returns any
   * @throws ApiError
   */
  public static getWsJobRepoZipById(
    data: $OpenApiTs['/api/{wsid}/jobs/{id}/repo/zip']['get']['req'],
  ): CancelablePromise<$OpenApiTs['/api/{wsid}/jobs/{id}/repo/zip']['get']['res'][200]> {
    const { wsid, id } = data;
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/{wsid}/jobs/{id}/repo/zip',
      path: {
        wsid,
        id,
      },
    });
  }

  /**
   * Get job status history
   * @returns any
   * @throws ApiError
   */
  public static getJobStatusHistory(
    data: $OpenApiTs['/api/{wsid}/jobs/{id}/status']['get']['req'],
  ): CancelablePromise<$OpenApiTs['/api/{wsid}/jobs/{id}/status']['get']['res'][200]> {
    const { id, wsid } = data;
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/{wsid}/jobs/{id}/status',
      path: {
        id,
        wsid,
      },
    });
  }

  /**
   * Get job assignee history
   * @returns any
   * @throws ApiError
   */
  public static getJobAssigneeHistory(
    data: $OpenApiTs['/api/{wsid}/jobs/{id}/assignee']['get']['req'],
  ): CancelablePromise<$OpenApiTs['/api/{wsid}/jobs/{id}/assignee']['get']['res'][200]> {
    const { id, wsid } = data;
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/{wsid}/jobs/{id}/assignee',
      path: {
        id,
        wsid,
      },
    });
  }

  /**
   * Get job locked status
   * @returns any
   * @throws ApiError
   */
  public static getJobLockedStatus(
    data: $OpenApiTs['/api/jobs/{id}/is-locked']['get']['req'],
  ): CancelablePromise<$OpenApiTs['/api/jobs/{id}/is-locked']['get']['res'][200]> {
    const { id } = data;
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/jobs/{id}/is-locked',
      path: {
        id,
      },
    });
  }

  /**
   * Get job locked status
   * @returns any
   * @throws ApiError
   */
  public static getJobLockedStatusByRecordingId(
    data: $OpenApiTs['/api/jobs/recording-session/{id}/is-locked']['get']['req'],
  ): CancelablePromise<$OpenApiTs['/api/jobs/recording-session/{id}/is-locked']['get']['res'][200]> {
    const { id } = data;
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/jobs/recording-session/{id}/is-locked',
      path: {
        id,
      },
    });
  }

  /**
   * Get job partial unlocked files
   * @returns any
   * @throws ApiError
   */
  public static getJobPartialUnlockedFiles(
    data: $OpenApiTs['/api/jobs/{id}/partial-unlocked-files']['get']['req'],
  ): CancelablePromise<$OpenApiTs['/api/jobs/{id}/partial-unlocked-files']['get']['res'][200]> {
    const { id } = data;
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/jobs/{id}/partial-unlocked-files',
      path: {
        id,
      },
    });
  }

  /**
   * Change job editing progress
   * @returns any
   * @throws ApiError
   */
  public static setEditingProgress(
    data: $OpenApiTs['/api/jobs/{jobId}/editing-progress']['post']['req'],
  ): CancelablePromise<$OpenApiTs['/api/jobs/{jobId}/editing-progress']['post']['res'][201]> {
    const { jobId, requestBody } = data;
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/jobs/{jobId}/editing-progress',
      path: {
        jobId,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * Post job comment
   * @returns any
   * @throws ApiError
   */
  public static commentJob(
    data: $OpenApiTs['/api/{wsid}/jobs/{id}/comment']['post']['req'],
  ): CancelablePromise<$OpenApiTs['/api/{wsid}/jobs/{id}/comment']['post']['res'][201]> {
    const { wsid, id, requestBody } = data;
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/{wsid}/jobs/{id}/comment',
      path: {
        wsid,
        id,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * Claim job for transcribing or proofreading
   * @returns successResponse
   * @throws ApiError
   */
  public static claimJob(
    data: $OpenApiTs['/api/{wsid}/jobs/{id}/claim']['post']['req'],
  ): CancelablePromise<$OpenApiTs['/api/{wsid}/jobs/{id}/claim']['post']['res'][200]> {
    const { wsid, id } = data;
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/{wsid}/jobs/{id}/claim',
      path: {
        wsid,
        id,
      },
    });
  }

  /**
   * Reassign job
   * @returns any
   * @throws ApiError
   */
  public static reassignJob(
    data: $OpenApiTs['/api/{wsid}/jobs/{id}/reassign']['post']['req'],
  ): CancelablePromise<$OpenApiTs['/api/{wsid}/jobs/{id}/reassign']['post']['res'][201]> {
    const { wsid, id, requestBody } = data;
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/{wsid}/jobs/{id}/reassign',
      path: {
        wsid,
        id,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * Update job case (repository)
   * @returns any
   * @throws ApiError
   */
  public static updateCase(
    data: $OpenApiTs['/api/{wsid}/jobs/{id}/case']['post']['req'],
  ): CancelablePromise<$OpenApiTs['/api/{wsid}/jobs/{id}/case']['post']['res'][201]> {
    const { wsid, id, requestBody } = data;
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/{wsid}/jobs/{id}/case',
      path: {
        wsid,
        id,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * Edit job notes
   * @returns any
   * @throws ApiError
   */
  public static editJobNotes(
    data: $OpenApiTs['/api/{wsid}/jobs/{id}/notes']['post']['req'],
  ): CancelablePromise<$OpenApiTs['/api/{wsid}/jobs/{id}/notes']['post']['res'][201]> {
    const { wsid, id, requestBody } = data;
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/{wsid}/jobs/{id}/notes',
      path: {
        wsid,
        id,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * Edit job tags
   * @returns any
   * @throws ApiError
   */
  public static editJobTags(
    data: $OpenApiTs['/api/{wsid}/jobs/{id}/tags']['post']['req'],
  ): CancelablePromise<$OpenApiTs['/api/{wsid}/jobs/{id}/tags']['post']['res'][201]> {
    const { wsid, id, requestBody } = data;
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/{wsid}/jobs/{id}/tags',
      path: {
        wsid,
        id,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * Delete job tag
   * @returns any
   * @throws ApiError
   */
  public static deleteTag(
    data: $OpenApiTs['/api/{wsid}/jobs/{id}/tags']['delete']['req'],
  ): CancelablePromise<$OpenApiTs['/api/{wsid}/jobs/{id}/tags']['delete']['res'][200]> {
    const { id, wsid, requestBody } = data;
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/api/{wsid}/jobs/{id}/tags',
      path: {
        id,
        wsid,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * Update job transcriptUnlockType
   * @returns any
   * @throws ApiError
   */
  public static updateJobTranscriptUnlockTypeAdmin(
    data: $OpenApiTs['/api/admin/jobs/{id}/transcript-unlock-type']['post']['req'],
  ): CancelablePromise<$OpenApiTs['/api/admin/jobs/{id}/transcript-unlock-type']['post']['res'][201]> {
    const { id, requestBody } = data;
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/admin/jobs/{id}/transcript-unlock-type',
      path: {
        id,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * Update job transcriptUnlockType
   * @returns any
   * @throws ApiError
   */
  public static updateJobTranscriptUnlockType(
    data: $OpenApiTs['/api/{wsid}/jobs/{id}/transcript-unlock-type']['post']['req'],
  ): CancelablePromise<$OpenApiTs['/api/{wsid}/jobs/{id}/transcript-unlock-type']['post']['res'][201]> {
    const { wsid, id, requestBody } = data;
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/{wsid}/jobs/{id}/transcript-unlock-type',
      path: {
        wsid,
        id,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * Update deadline
   * @returns any
   * @throws ApiError
   */
  public static updateDeadline(
    data: $OpenApiTs['/api/{wsid}/jobs/{id}/deadline']['post']['req'],
  ): CancelablePromise<$OpenApiTs['/api/{wsid}/jobs/{id}/deadline']['post']['res'][201]> {
    const { wsid, id, requestBody } = data;
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/{wsid}/jobs/{id}/deadline',
      path: {
        wsid,
        id,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * Move job to another WS for VS Admins
   * @returns any
   * @throws ApiError
   */
  public static adminMoveJobToOrgWs(
    data: $OpenApiTs['/api/admin/jobs/{id}/workspace']['post']['req'],
  ): CancelablePromise<$OpenApiTs['/api/admin/jobs/{id}/workspace']['post']['res'][201]> {
    const { id, requestBody } = data;
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/admin/jobs/{id}/workspace',
      path: {
        id,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * Move job to another WS
   * @returns any
   * @throws ApiError
   */
  public static moveJobToWs(
    data: $OpenApiTs['/api/{wsid}/jobs/{id}/workspace']['post']['req'],
  ): CancelablePromise<$OpenApiTs['/api/{wsid}/jobs/{id}/workspace']['post']['res'][201]> {
    const { wsid, id, requestBody } = data;
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/{wsid}/jobs/{id}/workspace',
      path: {
        wsid,
        id,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * Move jobs to another WS
   * @returns any
   * @throws ApiError
   */
  public static moveJobsToWs(
    data: $OpenApiTs['/api/{wsid}/jobs/workspace']['post']['req'],
  ): CancelablePromise<$OpenApiTs['/api/{wsid}/jobs/workspace']['post']['res'][201]> {
    const { wsid, requestBody } = data;
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/{wsid}/jobs/workspace',
      path: {
        wsid,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * Set job status to ready for proofreading (transcribing is complete)
   * @returns any
   * @throws ApiError
   */
  public static markJobAsReadyForProofreading(
    data: $OpenApiTs['/api/{wsid}/jobs/{id}/readyForProofreading']['post']['req'],
  ): CancelablePromise<$OpenApiTs['/api/{wsid}/jobs/{id}/readyForProofreading']['post']['res'][201]> {
    const { wsid, id } = data;
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/{wsid}/jobs/{id}/readyForProofreading',
      path: {
        wsid,
        id,
      },
    });
  }

  /**
   * Set job status to ready for final (proofreading is complete)
   * @returns any
   * @throws ApiError
   */
  public static markJobAsReadyForFinal(
    data: $OpenApiTs['/api/{wsid}/jobs/{id}/readyForFinal']['post']['req'],
  ): CancelablePromise<$OpenApiTs['/api/{wsid}/jobs/{id}/readyForFinal']['post']['res'][201]> {
    const { wsid, id } = data;
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/{wsid}/jobs/{id}/readyForFinal',
      path: {
        wsid,
        id,
      },
    });
  }

  /**
   * Set job status to complete
   * @returns any
   * @throws ApiError
   */
  public static markJobAsComplete(
    data: $OpenApiTs['/api/{wsid}/jobs/{id}/complete']['post']['req'],
  ): CancelablePromise<$OpenApiTs['/api/{wsid}/jobs/{id}/complete']['post']['res'][201]> {
    const { wsid, id } = data;
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/{wsid}/jobs/{id}/complete',
      path: {
        wsid,
        id,
      },
    });
  }

  /**
   * Resubmit job
   * @returns any
   * @throws ApiError
   */
  public static resubmitJobWs(
    data: $OpenApiTs['/api/{wsid}/jobs/{id}/resubmit']['post']['req'],
  ): CancelablePromise<$OpenApiTs['/api/{wsid}/jobs/{id}/resubmit']['post']['res'][201]> {
    const { id, wsid } = data;
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/{wsid}/jobs/{id}/resubmit',
      path: {
        id,
        wsid,
      },
    });
  }

  /**
   * Update job title
   * @returns any
   * @throws ApiError
   */
  public static updateTitle(
    data: $OpenApiTs['/api/{wsid}/jobs/{id}/name']['post']['req'],
  ): CancelablePromise<$OpenApiTs['/api/{wsid}/jobs/{id}/name']['post']['res'][201]> {
    const { id, wsid, requestBody } = data;
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/{wsid}/jobs/{id}/name',
      path: {
        id,
        wsid,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * Update job layout
   * @returns any
   * @throws ApiError
   */
  public static updateLayout(
    data: $OpenApiTs['/api/{wsid}/jobs/{id}/layout']['post']['req'],
  ): CancelablePromise<$OpenApiTs['/api/{wsid}/jobs/{id}/layout']['post']['res'][201]> {
    const { id, wsid, requestBody } = data;
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/{wsid}/jobs/{id}/layout',
      path: {
        id,
        wsid,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * @returns any
   * @throws ApiError
   */
  public static checkMediaInJob(
    data: $OpenApiTs['/api/jobs/{id}/check-media']['get']['req'],
  ): CancelablePromise<$OpenApiTs['/api/jobs/{id}/check-media']['get']['res'][200]> {
    const { id } = data;
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/jobs/{id}/check-media',
      path: {
        id,
      },
    });
  }

  /**
   * @returns GetJobWorkspacePermissionsResponseDto
   * @throws ApiError
   */
  public static getJobWorkspacePermissions(
    data: $OpenApiTs['/api/jobs/{id}/permissions']['get']['req'],
  ): CancelablePromise<$OpenApiTs['/api/jobs/{id}/permissions']['get']['res'][200]> {
    const { id } = data;
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/jobs/{id}/permissions',
      path: {
        id,
      },
    });
  }

  /**
   * @returns any
   * @throws ApiError
   */
  public static setTranscriptPreparerStarted(
    data: $OpenApiTs['/api/jobs/{id}/pipeline-status/transcript-preparer-started']['patch']['req'],
  ): CancelablePromise<$OpenApiTs['/api/jobs/{id}/pipeline-status/transcript-preparer-started']['patch']['res'][200]> {
    const { id } = data;
    return __request(OpenAPI, {
      method: 'PATCH',
      url: '/api/jobs/{id}/pipeline-status/transcript-preparer-started',
      path: {
        id,
      },
    });
  }

  /**
   * @returns any
   * @throws ApiError
   */
  public static setTranscriptPreparerFailed(): CancelablePromise<
    $OpenApiTs['/api/jobs/{id}/pipeline-status/transcript-preparer-failed']['patch']['res'][200]
  > {
    return __request(OpenAPI, {
      method: 'PATCH',
      url: '/api/jobs/{id}/pipeline-status/transcript-preparer-failed',
    });
  }

  /**
   * @returns any
   * @throws ApiError
   */
  public static setTranscriptPreparerCompleted(
    data: $OpenApiTs['/api/jobs/{id}/pipeline-status/transcript-preparer-completed']['patch']['req'],
  ): CancelablePromise<
    $OpenApiTs['/api/jobs/{id}/pipeline-status/transcript-preparer-completed']['patch']['res'][200]
  > {
    const { id, requestBody } = data;
    return __request(OpenAPI, {
      method: 'PATCH',
      url: '/api/jobs/{id}/pipeline-status/transcript-preparer-completed',
      path: {
        id,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * Update job layout and trigger transcript preparer
   * @returns any
   * @throws ApiError
   */
  public static regenerateWithNewLayout(
    data: $OpenApiTs['/api/{wsid}/jobs/{id}/regenerate-with-new-layout']['post']['req'],
  ): CancelablePromise<$OpenApiTs['/api/{wsid}/jobs/{id}/regenerate-with-new-layout']['post']['res'][201]> {
    const { id, wsid, requestBody } = data;
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/{wsid}/jobs/{id}/regenerate-with-new-layout',
      path: {
        id,
        wsid,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }
}

export class RepositoriesService {
  /**
   * Bulk create
   * @returns any
   * @throws ApiError
   */
  public static bulkCreateRepositoryJobs(
    data: $OpenApiTs['/api/repository/{repositoryId}/jobs/bulk']['post']['req'],
  ): CancelablePromise<$OpenApiTs['/api/repository/{repositoryId}/jobs/bulk']['post']['res'][201]> {
    const { repositoryId } = data;
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/repository/{repositoryId}/jobs/bulk',
      path: {
        repositoryId,
      },
    });
  }

  /**
   * @returns any
   * @throws ApiError
   */
  public static generateUploadParams(
    data: $OpenApiTs['/api/repositories/upload-params']['get']['req'],
  ): CancelablePromise<$OpenApiTs['/api/repositories/upload-params']['get']['res'][200]> {
    const { repositoryId, file } = data;
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/repositories/upload-params',
      query: {
        repositoryId,
        file,
      },
    });
  }

  /**
   * Create a new Repository
   * @returns any
   * @throws ApiError
   */
  public static create(
    data: $OpenApiTs['/api/repositories']['post']['req'],
  ): CancelablePromise<$OpenApiTs['/api/repositories']['post']['res'][201]> {
    const { requestBody } = data;
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/repositories',
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * Admin Find all Repository
   * @returns any
   * @throws ApiError
   */
  public static adminFindAll(): CancelablePromise<$OpenApiTs['/api/repositories']['get']['res'][200]> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/repositories',
    });
  }

  /**
   * Find a Repository
   * @returns any
   * @throws ApiError
   */
  public static findOne(
    data: $OpenApiTs['/api/repositories/{id}']['get']['req'],
  ): CancelablePromise<$OpenApiTs['/api/repositories/{id}']['get']['res'][200]> {
    const { id } = data;
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/repositories/{id}',
      path: {
        id,
      },
    });
  }

  /**
   * Update a Repository
   * @returns any
   * @throws ApiError
   */
  public static update(
    data: $OpenApiTs['/api/repositories/{id}']['patch']['req'],
  ): CancelablePromise<$OpenApiTs['/api/repositories/{id}']['patch']['res'][200]> {
    const { id, requestBody } = data;
    return __request(OpenAPI, {
      method: 'PATCH',
      url: '/api/repositories/{id}',
      path: {
        id,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * Delete a Repository
   * @returns any
   * @throws ApiError
   */
  public static remove(
    data: $OpenApiTs['/api/repositories/{id}']['delete']['req'],
  ): CancelablePromise<$OpenApiTs['/api/repositories/{id}']['delete']['res'][200]> {
    const { id } = data;
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/api/repositories/{id}',
      path: {
        id,
      },
    });
  }

  /**
   * Find a Repository
   * @returns any
   * @throws ApiError
   */
  public static adminFindOne(
    data: $OpenApiTs['/api/repositories/admin/{id}']['get']['req'],
  ): CancelablePromise<$OpenApiTs['/api/repositories/admin/{id}']['get']['res'][200]> {
    const { id } = data;
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/repositories/admin/{id}',
      path: {
        id,
      },
    });
  }

  /**
   * Find a Repository by slug
   * @returns any
   * @throws ApiError
   */
  public static findOneBySlug(
    data: $OpenApiTs['/api/repositories/slug/{orgSlug}/{slug}']['get']['req'],
  ): CancelablePromise<$OpenApiTs['/api/repositories/slug/{orgSlug}/{slug}']['get']['res'][200]> {
    const { orgSlug, slug } = data;
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/repositories/slug/{orgSlug}/{slug}',
      path: {
        orgSlug,
        slug,
      },
    });
  }

  /**
   * Check if the given slug is available (with except the existing repo)
   * @returns any
   * @throws ApiError
   */
  public static isRepositorySlugAvailable(
    data: $OpenApiTs['/api/repositories/is-available/{orgSlug}/{id}/{slug}']['get']['req'],
  ): CancelablePromise<$OpenApiTs['/api/repositories/is-available/{orgSlug}/{id}/{slug}']['get']['res'][200]> {
    const { orgSlug, id, slug } = data;
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/repositories/is-available/{orgSlug}/{id}/{slug}',
      path: {
        orgSlug,
        id,
        slug,
      },
    });
  }

  /**
   * Find all audio Repository attachments
   * @returns any
   * @throws ApiError
   */
  public static findAllAudioAttachments(
    data: $OpenApiTs['/api/repositories/{id}/attachments/audio']['get']['req'],
  ): CancelablePromise<$OpenApiTs['/api/repositories/{id}/attachments/audio']['get']['res'][200]> {
    const { id } = data;
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/repositories/{id}/attachments/audio',
      path: {
        id,
      },
    });
  }

  /**
   * Create a Repository attachment
   * @returns any
   * @throws ApiError
   */
  public static createAttachments(
    data: $OpenApiTs['/api/repositories/{id}/attachments']['post']['req'],
  ): CancelablePromise<$OpenApiTs['/api/repositories/{id}/attachments']['post']['res'][201]> {
    const { id, requestBody } = data;
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/repositories/{id}/attachments',
      path: {
        id,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * Download a Repository attachment
   * @returns any
   * @throws ApiError
   */
  public static downloadAttachment(
    data: $OpenApiTs['/api/repositories/attachments/{id}/download']['get']['req'],
  ): CancelablePromise<$OpenApiTs['/api/repositories/attachments/{id}/download']['get']['res'][200]> {
    const { id } = data;
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/repositories/attachments/{id}/download',
      path: {
        id,
      },
    });
  }

  /**
   * Delete a Repository attachment
   * @returns any
   * @throws ApiError
   */
  public static removeAttachments(
    data: $OpenApiTs['/api/repositories/attachments/{id}']['delete']['req'],
  ): CancelablePromise<$OpenApiTs['/api/repositories/attachments/{id}']['delete']['res'][200]> {
    const { id } = data;
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/api/repositories/attachments/{id}',
      path: {
        id,
      },
    });
  }

  /**
   * Reassign job
   * @returns any
   * @throws ApiError
   */
  public static reassignRepo(
    data: $OpenApiTs['/api/repositories/{id}/reassign']['post']['req'],
  ): CancelablePromise<$OpenApiTs['/api/repositories/{id}/reassign']['post']['res'][201]> {
    const { id } = data;
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/repositories/{id}/reassign',
      path: {
        id,
      },
    });
  }
}

export class MediaService {
  /**
   * @returns any
   * @throws ApiError
   */
  public static generateUploadParams(
    data: $OpenApiTs['/api/media/upload-params']['get']['req'],
  ): CancelablePromise<$OpenApiTs['/api/media/upload-params']['get']['res'][200]> {
    const { jobId, file } = data;
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/media/upload-params',
      query: {
        jobId,
        file,
      },
    });
  }

  /**
   * @returns any
   * @throws ApiError
   */
  public static enhanceMedia(
    data: $OpenApiTs['/api/media/{id}/enhance']['post']['req'],
  ): CancelablePromise<$OpenApiTs['/api/media/{id}/enhance']['post']['res'][201]> {
    const { id } = data;
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/media/{id}/enhance',
      path: {
        id,
      },
    });
  }

  /**
   * @returns any
   * @throws ApiError
   */
  public static createMedia(
    data: $OpenApiTs['/api/media']['post']['req'],
  ): CancelablePromise<$OpenApiTs['/api/media']['post']['res'][201]> {
    const { requestBody } = data;
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/media',
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * @returns any
   * @throws ApiError
   */
  public static deleteMedia(): CancelablePromise<$OpenApiTs['/api/media']['delete']['res'][200]> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/api/media',
    });
  }

  /**
   * @returns any
   * @throws ApiError
   */
  public static getAnalysisStatus(
    data: $OpenApiTs['/api/media/analysis-status/{id}']['get']['req'],
  ): CancelablePromise<$OpenApiTs['/api/media/analysis-status/{id}']['get']['res'][200]> {
    const { id } = data;
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/media/analysis-status/{id}',
      path: {
        id,
      },
    });
  }

  /**
   * @returns any
   * @throws ApiError
   */
  public static sendMediaToDiagnosis(
    data: $OpenApiTs['/api/media/{id}/send-to-diagnosis']['get']['req'],
  ): CancelablePromise<$OpenApiTs['/api/media/{id}/send-to-diagnosis']['get']['res'][200]> {
    const { id } = data;
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/media/{id}/send-to-diagnosis',
      path: {
        id,
      },
    });
  }

  /**
   * @returns any
   * @throws ApiError
   */
  public static copyRepositoryAttachmentsAsMedia(
    data: $OpenApiTs['/api/media/from-repository']['post']['req'],
  ): CancelablePromise<$OpenApiTs['/api/media/from-repository']['post']['res'][201]> {
    const { requestBody } = data;
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/media/from-repository',
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * @returns any
   * @throws ApiError
   */
  public static updateMedia(
    data: $OpenApiTs['/api/media/{jobId}/{id}']['post']['req'],
  ): CancelablePromise<$OpenApiTs['/api/media/{jobId}/{id}']['post']['res'][201]> {
    const { jobId, id, requestBody } = data;
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/media/{jobId}/{id}',
      path: {
        jobId,
        id,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * Download file
   * @returns any
   * @throws ApiError
   */
  public static versionDownload(
    data: $OpenApiTs['/api/media/{id}/versions/{versionId}']['get']['req'],
  ): CancelablePromise<$OpenApiTs['/api/media/{id}/versions/{versionId}']['get']['res'][200]> {
    const { id, versionId } = data;
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/media/{id}/versions/{versionId}',
      path: {
        id,
        versionId,
      },
    });
  }

  /**
   * Download file
   * @returns any
   * @throws ApiError
   */
  public static downloadEnhancedMediaFile(
    data: $OpenApiTs['/api/media/{id}/enhanced/{file}']['get']['req'],
  ): CancelablePromise<$OpenApiTs['/api/media/{id}/enhanced/{file}']['get']['res'][200]> {
    const { id, file } = data;
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/media/{id}/enhanced/{file}',
      path: {
        id,
        file,
      },
    });
  }

  /**
   * Download file
   * @returns any
   * @throws ApiError
   */
  public static downloadTranscriptFile(
    data: $OpenApiTs['/api/media/{id}/transcript/{file}']['get']['req'],
  ): CancelablePromise<$OpenApiTs['/api/media/{id}/transcript/{file}']['get']['res'][200]> {
    const { id, file } = data;
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/media/{id}/transcript/{file}',
      path: {
        id,
        file,
      },
    });
  }

  /**
   * Download backup file
   * @returns any
   * @throws ApiError
   */
  public static downloadBackupFile(
    data: $OpenApiTs['/api/media/{id}/backup/{file}']['get']['req'],
  ): CancelablePromise<$OpenApiTs['/api/media/{id}/backup/{file}']['get']['res'][200]> {
    const { id, file } = data;
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/media/{id}/backup/{file}',
      path: {
        id,
        file,
      },
    });
  }

  /**
   * Download file
   * @returns any
   * @throws ApiError
   */
  public static downloadAttachmentFile(
    data: $OpenApiTs['/api/media/{id}/attachments/{file}']['get']['req'],
  ): CancelablePromise<$OpenApiTs['/api/media/{id}/attachments/{file}']['get']['res'][200]> {
    const { id, file } = data;
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/media/{id}/attachments/{file}',
      path: {
        id,
        file,
      },
    });
  }

  /**
   * Download file
   * @returns any
   * @throws ApiError
   */
  public static downloadReporterNotesFile(
    data: $OpenApiTs['/api/media/{id}/reporter-notes/{file}']['get']['req'],
  ): CancelablePromise<$OpenApiTs['/api/media/{id}/reporter-notes/{file}']['get']['res'][200]> {
    const { id, file } = data;
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/media/{id}/reporter-notes/{file}',
      path: {
        id,
        file,
      },
    });
  }

  /**
   * Download file
   * @returns any
   * @throws ApiError
   */
  public static downloadMediaFile(
    data: $OpenApiTs['/api/media/{id}/{file}']['get']['req'],
  ): CancelablePromise<$OpenApiTs['/api/media/{id}/{file}']['get']['res'][200]> {
    const { id, file } = data;
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/media/{id}/{file}',
      path: {
        id,
        file,
      },
    });
  }

  /**
   * Signed URL
   * @returns SignedUrlDto
   * @throws ApiError
   */
  public static getSignedUrl(
    data: $OpenApiTs['/api/media/job/{id}/signed/{file}']['get']['req'],
  ): CancelablePromise<$OpenApiTs['/api/media/job/{id}/signed/{file}']['get']['res'][200]> {
    const { id, file } = data;
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/media/job/{id}/signed/{file}',
      path: {
        id,
        file,
      },
    });
  }

  /**
   * @returns any
   * @throws ApiError
   */
  public static getFilesList(
    data: $OpenApiTs['/api/media/{jobId}']['get']['req'],
  ): CancelablePromise<$OpenApiTs['/api/media/{jobId}']['get']['res'][200]> {
    const { jobId } = data;
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/media/{jobId}',
      path: {
        jobId,
      },
    });
  }

  /**
   * @returns any
   * @throws ApiError
   */
  public static getDesktopDownloadLinks(
    data: $OpenApiTs['/api/media/desktop/link/{jobId}']['get']['req'],
  ): CancelablePromise<$OpenApiTs['/api/media/desktop/link/{jobId}']['get']['res'][200]> {
    const { jobId } = data;
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/media/desktop/link/{jobId}',
      path: {
        jobId,
      },
    });
  }
}

export class DolbyApiService {
  /**
   * @returns any
   * @throws ApiError
   */
  public static receiveWebhook(): CancelablePromise<$OpenApiTs['/api/dolby-api/webhook']['post']['res'][201]> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/dolby-api/webhook',
    });
  }

  /**
   * @returns any
   * @throws ApiError
   */
  public static getJob(
    data: $OpenApiTs['/api/dolby-api/job/{jobId}']['get']['req'],
  ): CancelablePromise<$OpenApiTs['/api/dolby-api/job/{jobId}']['get']['res'][200]> {
    const { jobId } = data;
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/dolby-api/job/{jobId}',
      path: {
        jobId,
      },
    });
  }
}

export class UserService {
  /**
   * Get upload avatar params
   * @returns any
   * @throws ApiError
   */
  public static ftpUploads(): CancelablePromise<$OpenApiTs['/api/user/upload-params']['get']['res'][200]> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/user/upload-params',
    });
  }

  /**
   * Get user details
   * @returns any
   * @throws ApiError
   */
  public static getUserDetails(
    data: $OpenApiTs['/api/user/{oid}/{userId}']['get']['req'],
  ): CancelablePromise<$OpenApiTs['/api/user/{oid}/{userId}']['get']['res'][200]> {
    const { oid, userId } = data;
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/user/{oid}/{userId}',
      path: {
        oid,
        userId,
      },
    });
  }

  /**
   * Update user info
   * @returns any
   * @throws ApiError
   */
  public static updateAccount(
    data: $OpenApiTs['/api/user/account']['put']['req'],
  ): CancelablePromise<$OpenApiTs['/api/user/account']['put']['res'][200]> {
    const { requestBody } = data;
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/api/user/account',
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * Update agreement flag
   * @returns any
   * @throws ApiError
   */
  public static agreement(): CancelablePromise<$OpenApiTs['/api/user/agreement']['post']['res'][201]> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/user/agreement',
    });
  }

  /**
   * Upload avatar
   * @returns any
   * @throws ApiError
   */
  public static uploadAvatar(): CancelablePromise<$OpenApiTs['/api/user/avatar']['post']['res'][201]> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/user/avatar',
    });
  }

  /**
   * Delete avatar
   * @returns any
   * @throws ApiError
   */
  public static deleteAvatar(): CancelablePromise<$OpenApiTs['/api/user/avatar']['delete']['res'][200]> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/api/user/avatar',
    });
  }

  /**
   * Update onboarding flag
   * @returns any
   * @throws ApiError
   */
  public static onboarding(): CancelablePromise<$OpenApiTs['/api/user/onboarding']['post']['res'][201]> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/user/onboarding',
    });
  }

  /**
   * Update downloaded desktop flag
   * @returns any
   * @throws ApiError
   */
  public static downloadedClient(): CancelablePromise<$OpenApiTs['/api/user/downloadedDesktop']['post']['res'][201]> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/user/downloadedDesktop',
    });
  }
}

export class SubscriptionsService {
  /**
   * @returns any
   * @throws ApiError
   */
  public static create(
    data: $OpenApiTs['/api/billing-account/{baId}/subscription']['post']['req'],
  ): CancelablePromise<$OpenApiTs['/api/billing-account/{baId}/subscription']['post']['res'][201]> {
    const { baId, requestBody } = data;
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/billing-account/{baId}/subscription',
      path: {
        baId,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * @returns any
   * @throws ApiError
   */
  public static adminCreate(
    data: $OpenApiTs['/api/admin/billing-account/{baId}/subscription']['post']['req'],
  ): CancelablePromise<$OpenApiTs['/api/admin/billing-account/{baId}/subscription']['post']['res'][201]> {
    const { baId, requestBody } = data;
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/admin/billing-account/{baId}/subscription',
      path: {
        baId,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * @returns any
   * @throws ApiError
   */
  public static findAll(
    data: $OpenApiTs['/api/billing-account/{baId}/subscriptions']['get']['req'],
  ): CancelablePromise<$OpenApiTs['/api/billing-account/{baId}/subscriptions']['get']['res'][200]> {
    const { baId } = data;
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/billing-account/{baId}/subscriptions',
      path: {
        baId,
      },
    });
  }

  /**
   * @returns any
   * @throws ApiError
   */
  public static findOne(
    data: $OpenApiTs['/api/billing-account/{baId}/subscription/{id}']['get']['req'],
  ): CancelablePromise<$OpenApiTs['/api/billing-account/{baId}/subscription/{id}']['get']['res'][200]> {
    const { id, baId } = data;
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/billing-account/{baId}/subscription/{id}',
      path: {
        id,
        baId,
      },
    });
  }

  /**
   * @returns any
   * @throws ApiError
   */
  public static update(
    data: $OpenApiTs['/api/billing-account/{baId}/subscription/{id}']['patch']['req'],
  ): CancelablePromise<$OpenApiTs['/api/billing-account/{baId}/subscription/{id}']['patch']['res'][200]> {
    const { id, baId, requestBody } = data;
    return __request(OpenAPI, {
      method: 'PATCH',
      url: '/api/billing-account/{baId}/subscription/{id}',
      path: {
        id,
        baId,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * @returns any
   * @throws ApiError
   */
  public static remove(
    data: $OpenApiTs['/api/billing-account/{baId}/subscription/{id}']['delete']['req'],
  ): CancelablePromise<$OpenApiTs['/api/billing-account/{baId}/subscription/{id}']['delete']['res'][200]> {
    const { baId, id } = data;
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/api/billing-account/{baId}/subscription/{id}',
      path: {
        baId,
        id,
      },
    });
  }

  /**
   * @returns any
   * @throws ApiError
   */
  public static adminFindOne(
    data: $OpenApiTs['/api/admin/subscription/{id}']['get']['req'],
  ): CancelablePromise<$OpenApiTs['/api/admin/subscription/{id}']['get']['res'][200]> {
    const { id } = data;
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/admin/subscription/{id}',
      path: {
        id,
      },
    });
  }

  /**
   * @returns any
   * @throws ApiError
   */
  public static adminRemove(
    data: $OpenApiTs['/api/admin/subscription/{id}']['delete']['req'],
  ): CancelablePromise<$OpenApiTs['/api/admin/subscription/{id}']['delete']['res'][200]> {
    const { id } = data;
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/api/admin/subscription/{id}',
      path: {
        id,
      },
    });
  }

  /**
   * Get Organization members list available to assign license
   * @returns any
   * @throws ApiError
   */
  public static getOrgMembers(
    data: $OpenApiTs['/api/billing-account/{baId}/subscription/{id}/available-members']['get']['req'],
  ): CancelablePromise<
    $OpenApiTs['/api/billing-account/{baId}/subscription/{id}/available-members']['get']['res'][200]
  > {
    const { baId, id, pageNo, pageSize, orderBy, orderType, search } = data;
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/billing-account/{baId}/subscription/{id}/available-members',
      path: {
        baId,
        id,
      },
      query: {
        pageNo,
        pageSize,
        orderBy,
        orderType,
        search,
      },
    });
  }

  /**
   * @returns any
   * @throws ApiError
   */
  public static getLicenses(
    data: $OpenApiTs['/api/billing-account/{baId}/subscription/{id}/licenses']['get']['req'],
  ): CancelablePromise<$OpenApiTs['/api/billing-account/{baId}/subscription/{id}/licenses']['get']['res'][200]> {
    const { baId, id } = data;
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/billing-account/{baId}/subscription/{id}/licenses',
      path: {
        baId,
        id,
      },
    });
  }

  /**
   * @returns any
   * @throws ApiError
   */
  public static adminGetLicenses(
    data: $OpenApiTs['/api/admin/subscription/{id}/licenses']['get']['req'],
  ): CancelablePromise<$OpenApiTs['/api/admin/subscription/{id}/licenses']['get']['res'][200]> {
    const { id } = data;
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/admin/subscription/{id}/licenses',
      path: {
        id,
      },
    });
  }

  /**
   * @returns any
   * @throws ApiError
   */
  public static assignLicense(
    data: $OpenApiTs['/api/billing-account/{baId}/assign-license']['put']['req'],
  ): CancelablePromise<$OpenApiTs['/api/billing-account/{baId}/assign-license']['put']['res'][200]> {
    const { baId, requestBody } = data;
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/api/billing-account/{baId}/assign-license',
      path: {
        baId,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * @returns any
   * @throws ApiError
   */
  public static updateLicenseTranscriptUnlockType(
    data: $OpenApiTs['/api/billing-account/{baId}/license/{licenseId}/transcript-unlock-type']['put']['req'],
  ): CancelablePromise<
    $OpenApiTs['/api/billing-account/{baId}/license/{licenseId}/transcript-unlock-type']['put']['res'][200]
  > {
    const { baId, licenseId, requestBody } = data;
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/api/billing-account/{baId}/license/{licenseId}/transcript-unlock-type',
      path: {
        baId,
        licenseId,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * @returns any
   * @throws ApiError
   */
  public static updateLicenseBackupRecordingFlag(
    data: $OpenApiTs['/api/billing-account/{baId}/license/{licenseId}/backup-recording-flag']['put']['req'],
  ): CancelablePromise<
    $OpenApiTs['/api/billing-account/{baId}/license/{licenseId}/backup-recording-flag']['put']['res'][200]
  > {
    const { baId, licenseId, requestBody } = data;
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/api/billing-account/{baId}/license/{licenseId}/backup-recording-flag',
      path: {
        baId,
        licenseId,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * @returns any
   * @throws ApiError
   */
  public static updateSubscriptionTranscriptUnlockTypes(
    data: $OpenApiTs['/api/billing-account/{baId}/subscription/{subscriptionId}/transcript-unlock-type']['put']['req'],
  ): CancelablePromise<
    $OpenApiTs['/api/billing-account/{baId}/subscription/{subscriptionId}/transcript-unlock-type']['put']['res'][200]
  > {
    const { baId, subscriptionId, requestBody } = data;
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/api/billing-account/{baId}/subscription/{subscriptionId}/transcript-unlock-type',
      path: {
        baId,
        subscriptionId,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * @returns any
   * @throws ApiError
   */
  public static adminUpdateSubscriptionTranscriptUnlockTypes(
    data: $OpenApiTs['/api/admin/billing-account/{baId}/subscription/{subscriptionId}/transcript-unlock-type']['put']['req'],
  ): CancelablePromise<
    $OpenApiTs['/api/admin/billing-account/{baId}/subscription/{subscriptionId}/transcript-unlock-type']['put']['res'][200]
  > {
    const { baId, subscriptionId, requestBody } = data;
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/api/admin/billing-account/{baId}/subscription/{subscriptionId}/transcript-unlock-type',
      path: {
        baId,
        subscriptionId,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * @returns any
   * @throws ApiError
   */
  public static adminUpdateLicenseTranscriptUnlockType(
    data: $OpenApiTs['/api/admin/billing-account/{baId}/license/{licenseId}/transcript-unlock-type']['put']['req'],
  ): CancelablePromise<
    $OpenApiTs['/api/admin/billing-account/{baId}/license/{licenseId}/transcript-unlock-type']['put']['res'][200]
  > {
    const { baId, licenseId, requestBody } = data;
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/api/admin/billing-account/{baId}/license/{licenseId}/transcript-unlock-type',
      path: {
        baId,
        licenseId,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }
}

export class StripeService {
  /**
   * Stripe webhook
   * @returns any
   * @throws ApiError
   */
  public static stripeWebhook(
    data: $OpenApiTs['/api/stripe/{key}']['post']['req'],
  ): CancelablePromise<$OpenApiTs['/api/stripe/{key}']['post']['res'][201]> {
    const { key } = data;
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/stripe/{key}',
      path: {
        key,
      },
    });
  }
}

export class BillingAccountService {
  /**
   * Get available plans
   * @returns any
   * @throws ApiError
   */
  public static getAsOnePlans(): CancelablePromise<
    $OpenApiTs['/api/billing-account/subscription-plans']['get']['res'][200]
  > {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/billing-account/subscription-plans',
    });
  }

  /**
   * Get all plans (even unpublished)
   * @returns any
   * @throws ApiError
   */
  public static getAllAsOnePlans(): CancelablePromise<
    $OpenApiTs['/api/billing-account/subscription-plans/all']['get']['res'][200]
  > {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/billing-account/subscription-plans/all',
    });
  }

  /**
   * View a Billing Account
   * @returns any
   * @throws ApiError
   */
  public static findOne(
    data: $OpenApiTs['/api/billing-account/{baId}']['get']['req'],
  ): CancelablePromise<$OpenApiTs['/api/billing-account/{baId}']['get']['res'][200]> {
    const { baId } = data;
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/billing-account/{baId}',
      path: {
        baId,
      },
    });
  }

  /**
   * Update a Billing Account for an Organization
   * @returns any
   * @throws ApiError
   */
  public static update(
    data: $OpenApiTs['/api/billing-account/{baId}']['patch']['req'],
  ): CancelablePromise<$OpenApiTs['/api/billing-account/{baId}']['patch']['res'][200]> {
    const { baId, requestBody } = data;
    return __request(OpenAPI, {
      method: 'PATCH',
      url: '/api/billing-account/{baId}',
      path: {
        baId,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * View a Billing Account (for VS Admin)
   * @returns any
   * @throws ApiError
   */
  public static adminFindOne(
    data: $OpenApiTs['/api/billing-account/admin/{baId}']['get']['req'],
  ): CancelablePromise<$OpenApiTs['/api/billing-account/admin/{baId}']['get']['res'][200]> {
    const { baId } = data;
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/billing-account/admin/{baId}',
      path: {
        baId,
      },
    });
  }

  /**
   * Update a Billing Account auto renew flag
   * @returns any
   * @throws ApiError
   */
  public static setAutoRenew(
    data: $OpenApiTs['/api/billing-account/{baId}/auto-renew']['patch']['req'],
  ): CancelablePromise<$OpenApiTs['/api/billing-account/{baId}/auto-renew']['patch']['res'][200]> {
    const { baId } = data;
    return __request(OpenAPI, {
      method: 'PATCH',
      url: '/api/billing-account/{baId}/auto-renew',
      path: {
        baId,
      },
    });
  }

  /**
   * Update a Billing Account auto top up settings
   * @returns any
   * @throws ApiError
   */
  public static setAutoTopUpSettings(
    data: $OpenApiTs['/api/billing-account/{baId}/auto-top-up-settings']['patch']['req'],
  ): CancelablePromise<$OpenApiTs['/api/billing-account/{baId}/auto-top-up-settings']['patch']['res'][200]> {
    const { baId, requestBody } = data;
    return __request(OpenAPI, {
      method: 'PATCH',
      url: '/api/billing-account/{baId}/auto-top-up-settings',
      path: {
        baId,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * List transactions
   * @returns any
   * @throws ApiError
   */
  public static getTransacations(
    data: $OpenApiTs['/api/billing-account/{baId}/transactions']['get']['req'],
  ): CancelablePromise<$OpenApiTs['/api/billing-account/{baId}/transactions']['get']['res'][200]> {
    const { baId } = data;
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/billing-account/{baId}/transactions',
      path: {
        baId,
      },
    });
  }

  /**
   * List transactions (for VS Admin)
   * @returns any
   * @throws ApiError
   */
  public static adminGetTransacations(
    data: $OpenApiTs['/api/billing-account/admin/{baId}/transactions']['get']['req'],
  ): CancelablePromise<$OpenApiTs['/api/billing-account/admin/{baId}/transactions']['get']['res'][200]> {
    const { baId } = data;
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/billing-account/admin/{baId}/transactions',
      path: {
        baId,
      },
    });
  }
}

export class PaymentService {
  /**
   * @returns any
   * @throws ApiError
   */
  public static createPaymentIntent(
    data: $OpenApiTs['/api/payment/billing-account/{baId}/payment']['post']['req'],
  ): CancelablePromise<$OpenApiTs['/api/payment/billing-account/{baId}/payment']['post']['res'][201]> {
    const { baId, requestBody } = data;
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/payment/billing-account/{baId}/payment',
      path: {
        baId,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * @returns any
   * @throws ApiError
   */
  public static billingAccountSavePaymentForJobSubmit(
    data: $OpenApiTs['/api/payment/billing-account/{baId}/payment/job-submit']['post']['req'],
  ): CancelablePromise<$OpenApiTs['/api/payment/billing-account/{baId}/payment/job-submit']['post']['res'][201]> {
    const { baId } = data;
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/payment/billing-account/{baId}/payment/job-submit',
      path: {
        baId,
      },
    });
  }

  /**
   * @returns any
   * @throws ApiError
   */
  public static confirmPaymentIntent(): CancelablePromise<
    $OpenApiTs['/api/payment/billing-account/payment/confirm']['patch']['res'][200]
  > {
    return __request(OpenAPI, {
      method: 'PATCH',
      url: '/api/payment/billing-account/payment/confirm',
    });
  }

  /**
   * @returns any
   * @throws ApiError
   */
  public static getPaymentIntent(
    data: $OpenApiTs['/api/payment/getPaymentIntent']['get']['req'],
  ): CancelablePromise<$OpenApiTs['/api/payment/getPaymentIntent']['get']['res'][200]> {
    const { id } = data;
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/payment/getPaymentIntent',
      query: {
        id,
      },
    });
  }

  /**
   * @returns PaymentMethodListDto
   * @throws ApiError
   */
  public static billingAccountPaymentMethodList(
    data: $OpenApiTs['/api/payment/billing-account/{baId}/payment-methods']['get']['req'],
  ): CancelablePromise<$OpenApiTs['/api/payment/billing-account/{baId}/payment-methods']['get']['res'][200]> {
    const { baId } = data;
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/payment/billing-account/{baId}/payment-methods',
      path: {
        baId,
      },
    });
  }

  /**
   * @returns any
   * @throws ApiError
   */
  public static adminBillingAccountPaymentMethodList(
    data: $OpenApiTs['/api/payment/admin/billing-account/{baId}/payment-methods']['get']['req'],
  ): CancelablePromise<$OpenApiTs['/api/payment/admin/billing-account/{baId}/payment-methods']['get']['res'][200]> {
    const { baId } = data;
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/payment/admin/billing-account/{baId}/payment-methods',
      path: {
        baId,
      },
    });
  }

  /**
   * @returns any
   * @throws ApiError
   */
  public static billingAccountPaymentMethodListForJobSubmission(
    data: $OpenApiTs['/api/payment/billing-account/{baId}/payment-methods/job-submit']['get']['req'],
  ): CancelablePromise<
    $OpenApiTs['/api/payment/billing-account/{baId}/payment-methods/job-submit']['get']['res'][200]
  > {
    const { baId } = data;
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/payment/billing-account/{baId}/payment-methods/job-submit',
      path: {
        baId,
      },
    });
  }

  /**
   * @returns any
   * @throws ApiError
   */
  public static billingAccountSetDefaultPaymentMethod(
    data: $OpenApiTs['/api/payment/billing-account/{baId}/payment-method/{paymentMethodId}/set-default']['patch']['req'],
  ): CancelablePromise<
    $OpenApiTs['/api/payment/billing-account/{baId}/payment-method/{paymentMethodId}/set-default']['patch']['res'][200]
  > {
    const { baId, paymentMethodId } = data;
    return __request(OpenAPI, {
      method: 'PATCH',
      url: '/api/payment/billing-account/{baId}/payment-method/{paymentMethodId}/set-default',
      path: {
        baId,
        paymentMethodId,
      },
    });
  }

  /**
   * @returns any
   * @throws ApiError
   */
  public static billingAccountReceipts(
    data: $OpenApiTs['/api/payment/billing-account/{baId}/receipts']['get']['req'],
  ): CancelablePromise<$OpenApiTs['/api/payment/billing-account/{baId}/receipts']['get']['res'][200]> {
    const { baId } = data;
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/payment/billing-account/{baId}/receipts',
      path: {
        baId,
      },
    });
  }

  /**
   * @returns any
   * @throws ApiError
   */
  public static billingAccountCancelPaymentMethod(
    data: $OpenApiTs['/api/payment/billing-account/{baId}/payment-method/{paymentMethodId}']['delete']['req'],
  ): CancelablePromise<
    $OpenApiTs['/api/payment/billing-account/{baId}/payment-method/{paymentMethodId}']['delete']['res'][200]
  > {
    const { baId, paymentMethodId } = data;
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/api/payment/billing-account/{baId}/payment-method/{paymentMethodId}',
      path: {
        baId,
        paymentMethodId,
      },
    });
  }

  /**
   * @returns any
   * @throws ApiError
   */
  public static billingAccountCreateBankAccount(
    data: $OpenApiTs['/api/payment/billing-account/{baId}/bank-account']['post']['req'],
  ): CancelablePromise<$OpenApiTs['/api/payment/billing-account/{baId}/bank-account']['post']['res'][201]> {
    const { baId } = data;
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/payment/billing-account/{baId}/bank-account',
      path: {
        baId,
      },
    });
  }

  /**
   * @returns any
   * @throws ApiError
   */
  public static billingAccountAddPaymentMethod(
    data: $OpenApiTs['/api/payment/billing-account/{baId}/payment-method']['post']['req'],
  ): CancelablePromise<$OpenApiTs['/api/payment/billing-account/{baId}/payment-method']['post']['res'][201]> {
    const { baId, requestBody } = data;
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/payment/billing-account/{baId}/payment-method',
      path: {
        baId,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * Get invoices
   * @returns any
   * @throws ApiError
   */
  public static billingAccountGetInvoices(
    data: $OpenApiTs['/api/payment/billing-account/{baId}/invoices']['get']['req'],
  ): CancelablePromise<$OpenApiTs['/api/payment/billing-account/{baId}/invoices']['get']['res'][200]> {
    const { baId } = data;
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/payment/billing-account/{baId}/invoices',
      path: {
        baId,
      },
    });
  }

  /**
   * Get invoice data
   * @returns any
   * @throws ApiError
   */
  public static getInvoice(
    data: $OpenApiTs['/api/payment/billing-account/{baId}/invoice/{invoiceId}']['get']['req'],
  ): CancelablePromise<$OpenApiTs['/api/payment/billing-account/{baId}/invoice/{invoiceId}']['get']['res'][200]> {
    const { baId, invoiceId } = data;
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/payment/billing-account/{baId}/invoice/{invoiceId}',
      path: {
        baId,
        invoiceId,
      },
    });
  }
}

export class PayService {
  /**
   * Job submit endpoint
   * @returns any
   * @throws ApiError
   */
  public static pay(
    data: $OpenApiTs['/api/pay/{id}']['post']['req'],
  ): CancelablePromise<$OpenApiTs['/api/pay/{id}']['post']['res'][201]> {
    const { id, requestBody } = data;
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/pay/{id}',
      path: {
        id,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * Job partial unlock charge
   * @returns any
   * @throws ApiError
   */
  public static partialCharge(
    data: $OpenApiTs['/api/pay/{id}/partial-unlock']['post']['req'],
  ): CancelablePromise<$OpenApiTs['/api/pay/{id}/partial-unlock']['post']['res'][201]> {
    const { id } = data;
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/pay/{id}/partial-unlock',
      path: {
        id,
      },
    });
  }

  /**
   * Job bulk submit endpoint
   * @returns any
   * @throws ApiError
   */
  public static payForBulkJobs(
    data: $OpenApiTs['/api/pay/bulk/submit']['post']['req'],
  ): CancelablePromise<$OpenApiTs['/api/pay/bulk/submit']['post']['res'][201]> {
    const { requestBody } = data;
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/pay/bulk/submit',
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * ASOne Realtime Job submit endpoint
   * @returns any
   * @throws ApiError
   */
  public static payRealtime(
    data: $OpenApiTs['/api/pay/{baId}/realtime/{id}']['post']['req'],
  ): CancelablePromise<$OpenApiTs['/api/pay/{baId}/realtime/{id}']['post']['res'][201]> {
    const { baId, id } = data;
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/pay/{baId}/realtime/{id}',
      path: {
        baId,
        id,
      },
    });
  }
}

export class AdminService {
  /**
   * Dashboard info
   * @returns getDashboardInfoResponse
   * @throws ApiError
   */
  public static getDashboardInfo(): CancelablePromise<$OpenApiTs['/api/admin/dashboard']['get']['res'][200]> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/admin/dashboard',
    });
  }

  /**
   * Updates user email
   * @returns successResponse
   * @throws ApiError
   */
  public static updateUserEmail(
    data: $OpenApiTs['/api/admin/user/{id}/email']['post']['req'],
  ): CancelablePromise<$OpenApiTs['/api/admin/user/{id}/email']['post']['res'][200]> {
    const { id, requestBody } = data;
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/admin/user/{id}/email',
      path: {
        id,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * Updates user phone
   * @returns successResponse
   * @throws ApiError
   */
  public static updateUserPhone(
    data: $OpenApiTs['/api/admin/user/{id}/phone']['post']['req'],
  ): CancelablePromise<$OpenApiTs['/api/admin/user/{id}/phone']['post']['res'][200]> {
    const { id, requestBody } = data;
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/admin/user/{id}/phone',
      path: {
        id,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * Create user
   * @returns successResponse
   * @throws ApiError
   */
  public static createUser(
    data: $OpenApiTs['/api/admin/user']['post']['req'],
  ): CancelablePromise<$OpenApiTs['/api/admin/user']['post']['res'][200]> {
    const { requestBody } = data;
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/admin/user',
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * Get all AutoScriptOne plans
   * @returns any
   * @throws ApiError
   */
  public static getAllAsOnePlans(): CancelablePromise<$OpenApiTs['/api/admin/as-one-plans']['get']['res'][200]> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/admin/as-one-plans',
    });
  }

  /**
   * Get organization invitations
   * @returns any
   * @throws ApiError
   */
  public static getInvitations(
    data: $OpenApiTs['/api/admin/{oid}/invitations']['get']['req'],
  ): CancelablePromise<$OpenApiTs['/api/admin/{oid}/invitations']['get']['res'][200]> {
    const { oid } = data;
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/admin/{oid}/invitations',
      path: {
        oid,
      },
    });
  }

  /**
   * Create organization invitation
   * @returns any
   * @throws ApiError
   */
  public static createWsInvitation(
    data: $OpenApiTs['/api/admin/{oid}/invitations']['post']['req'],
  ): CancelablePromise<$OpenApiTs['/api/admin/{oid}/invitations']['post']['res'][201]> {
    const { oid, requestBody } = data;
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/admin/{oid}/invitations',
      path: {
        oid,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * Get organization teams
   * @returns any
   * @throws ApiError
   */
  public static getTeams(
    data: $OpenApiTs['/api/admin/{oid}/teams']['get']['req'],
  ): CancelablePromise<$OpenApiTs['/api/admin/{oid}/teams']['get']['res'][200]> {
    const { oid } = data;
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/admin/{oid}/teams',
      path: {
        oid,
      },
    });
  }

  /**
   * Get organization workspaces list
   * @returns any
   * @throws ApiError
   */
  public static getOrganizationWorkspaces(
    data: $OpenApiTs['/api/admin/{oid}/workspaces']['get']['req'],
  ): CancelablePromise<$OpenApiTs['/api/admin/{oid}/workspaces']['get']['res'][200]> {
    const { oid } = data;
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/admin/{oid}/workspaces',
      path: {
        oid,
      },
    });
  }

  /**
   * Edit existing invitation
   * @returns any
   * @throws ApiError
   */
  public static editInvitation(
    data: $OpenApiTs['/api/admin/invitations/{id}/edit']['post']['req'],
  ): CancelablePromise<$OpenApiTs['/api/admin/invitations/{id}/edit']['post']['res'][200]> {
    const { id, requestBody } = data;
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/admin/invitations/{id}/edit',
      path: {
        id,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * Resend email for existing invitation
   * @returns void
   * @throws ApiError
   */
  public static resendInvitation(
    data: $OpenApiTs['/api/admin/invitations/{id}/resend']['post']['req'],
  ): CancelablePromise<$OpenApiTs['/api/admin/invitations/{id}/resend']['post']['res'][204]> {
    const { id } = data;
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/admin/invitations/{id}/resend',
      path: {
        id,
      },
    });
  }

  /**
   * Change organization ASOneAllowed flag
   * @returns any
   * @throws ApiError
   */
  public static changeAsOneAllowed(
    data: $OpenApiTs['/api/admin/{oid}/as-one-allowed']['post']['req'],
  ): CancelablePromise<$OpenApiTs['/api/admin/{oid}/as-one-allowed']['post']['res'][201]> {
    const { oid, requestBody } = data;
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/admin/{oid}/as-one-allowed',
      path: {
        oid,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * Delete organization invitation
   * @returns any
   * @throws ApiError
   */
  public static deleteWsInvitation(
    data: $OpenApiTs['/api/admin/{oid}/invitations/{iid}']['delete']['req'],
  ): CancelablePromise<$OpenApiTs['/api/admin/{oid}/invitations/{iid}']['delete']['res'][200]> {
    const { oid, iid } = data;
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/api/admin/{oid}/invitations/{iid}',
      path: {
        oid,
        iid,
      },
    });
  }

  /**
   * Get organizations list
   * @returns any
   * @throws ApiError
   */
  public static getOrganizationsList(
    data: $OpenApiTs['/api/admin/organizations']['get']['req'],
  ): CancelablePromise<$OpenApiTs['/api/admin/organizations']['get']['res'][200]> {
    const { pageNo, pageSize, orderBy, orderType, search } = data;
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/admin/organizations',
      query: {
        pageNo,
        pageSize,
        orderBy,
        orderType,
        search,
      },
    });
  }

  /**
   * Get all organizations list
   * @returns any
   * @throws ApiError
   */
  public static getAllOrganizationsList(): CancelablePromise<
    $OpenApiTs['/api/admin/organizations/all']['get']['res'][200]
  > {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/admin/organizations/all',
    });
  }

  /**
   * Get organization data
   * @returns any
   * @throws ApiError
   */
  public static getOrganization(
    data: $OpenApiTs['/api/admin/organizations/{id}']['get']['req'],
  ): CancelablePromise<$OpenApiTs['/api/admin/organizations/{id}']['get']['res'][200]> {
    const { id } = data;
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/admin/organizations/{id}',
      path: {
        id,
      },
    });
  }

  /**
   * Get billing accounts list
   * @returns any
   * @throws ApiError
   */
  public static getBillingAccountsList(
    data: $OpenApiTs['/api/admin/billing-accounts']['get']['req'],
  ): CancelablePromise<$OpenApiTs['/api/admin/billing-accounts']['get']['res'][200]> {
    const { pageNo, pageSize, orderBy, orderType, search } = data;
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/admin/billing-accounts',
      query: {
        pageNo,
        pageSize,
        orderBy,
        orderType,
        search,
      },
    });
  }

  /**
   * Get billing account
   * @returns any
   * @throws ApiError
   */
  public static getBillingAccount(
    data: $OpenApiTs['/api/admin/billing-accounts/{baId}']['get']['req'],
  ): CancelablePromise<$OpenApiTs['/api/admin/billing-accounts/{baId}']['get']['res'][200]> {
    const { baId } = data;
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/admin/billing-accounts/{baId}',
      path: {
        baId,
      },
    });
  }

  /**
   * Get transactions list
   * @returns any
   * @throws ApiError
   */
  public static getTransactionsList(
    data: $OpenApiTs['/api/admin/transactions']['get']['req'],
  ): CancelablePromise<$OpenApiTs['/api/admin/transactions']['get']['res'][200]> {
    const { pageNo, pageSize, orderBy, orderType, search, from, to } = data;
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/admin/transactions',
      query: {
        pageNo,
        pageSize,
        orderBy,
        orderType,
        search,
        from,
        to,
      },
    });
  }

  /**
   * Create an Admin initiated transaction
   * @returns any
   * @throws ApiError
   */
  public static recalculateBalances(
    data: $OpenApiTs['/api/admin/billing-account/{baId}/recalculate']['put']['req'],
  ): CancelablePromise<$OpenApiTs['/api/admin/billing-account/{baId}/recalculate']['put']['res'][200]> {
    const { baId } = data;
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/api/admin/billing-account/{baId}/recalculate',
      path: {
        baId,
      },
    });
  }

  /**
   * Create an Admin initiated transaction
   * @returns any
   * @throws ApiError
   */
  public static addAdminTransaction(
    data: $OpenApiTs['/api/admin/billing-account/{baId}/transaction']['post']['req'],
  ): CancelablePromise<$OpenApiTs['/api/admin/billing-account/{baId}/transaction']['post']['res'][201]> {
    const { baId, requestBody } = data;
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/admin/billing-account/{baId}/transaction',
      path: {
        baId,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * Add Good Will balance to the Free Credit billing account
   * @returns any
   * @throws ApiError
   */
  public static addMainBalanceToBillingAccount(
    data: $OpenApiTs['/api/admin/billing-account/{baId}/balance']['post']['req'],
  ): CancelablePromise<$OpenApiTs['/api/admin/billing-account/{baId}/balance']['post']['res'][201]> {
    const { baId } = data;
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/admin/billing-account/{baId}/balance',
      path: {
        baId,
      },
    });
  }

  /**
   * Create a recording session
   * @returns any
   * @throws ApiError
   */
  public static createRecordingSession(
    data: $OpenApiTs['/api/admin/recording-session']['post']['req'],
  ): CancelablePromise<$OpenApiTs['/api/admin/recording-session']['post']['res'][201]> {
    const { requestBody } = data;
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/admin/recording-session',
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * Create a recording session
   * @returns any
   * @throws ApiError
   */
  public static updateRecordingSession(
    data: $OpenApiTs['/api/admin/recording-session/{id}']['put']['req'],
  ): CancelablePromise<$OpenApiTs['/api/admin/recording-session/{id}']['put']['res'][200]> {
    const { id, requestBody } = data;
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/api/admin/recording-session/{id}',
      path: {
        id,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * Update a Billing Account credit balance
   * @returns any
   * @throws ApiError
   */
  public static setCreditBalance(
    data: $OpenApiTs['/api/admin/billing-account/{baId}/credit-balance']['patch']['req'],
  ): CancelablePromise<$OpenApiTs['/api/admin/billing-account/{baId}/credit-balance']['patch']['res'][200]> {
    const { baId } = data;
    return __request(OpenAPI, {
      method: 'PATCH',
      url: '/api/admin/billing-account/{baId}/credit-balance',
      path: {
        baId,
      },
    });
  }

  /**
   * Update a Billing Account rate
   * @returns any
   * @throws ApiError
   */
  public static setBillingAccountRate(
    data: $OpenApiTs['/api/admin/billing-account/{baId}/rate']['patch']['req'],
  ): CancelablePromise<$OpenApiTs['/api/admin/billing-account/{baId}/rate']['patch']['res'][200]> {
    const { baId, requestBody } = data;
    return __request(OpenAPI, {
      method: 'PATCH',
      url: '/api/admin/billing-account/{baId}/rate',
      path: {
        baId,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * Update Billing Account rates
   * @returns successResponse
   * @throws ApiError
   */
  public static setBillingAccountRates(
    data: $OpenApiTs['/api/admin/billing-account/{baId}/rates']['patch']['req'],
  ): CancelablePromise<$OpenApiTs['/api/admin/billing-account/{baId}/rates']['patch']['res'][200]> {
    const { baId, requestBody } = data;
    return __request(OpenAPI, {
      method: 'PATCH',
      url: '/api/admin/billing-account/{baId}/rates',
      path: {
        baId,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * Get workspaces list
   * @returns any
   * @throws ApiError
   */
  public static getWorkspacesList(
    data: $OpenApiTs['/api/admin/workspaces']['get']['req'],
  ): CancelablePromise<$OpenApiTs['/api/admin/workspaces']['get']['res'][200]> {
    const { pageNo, pageSize, orderBy, orderType, search } = data;
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/admin/workspaces',
      query: {
        pageNo,
        pageSize,
        orderBy,
        orderType,
        search,
      },
    });
  }

  /**
   * Get all workspaces list
   * @returns any
   * @throws ApiError
   */
  public static getAllWorkspacesList(): CancelablePromise<$OpenApiTs['/api/admin/workspaces/all']['get']['res'][200]> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/admin/workspaces/all',
    });
  }

  /**
   * Get organization invitations list
   * @returns any
   * @throws ApiError
   */
  public static getOrganizationInvitationsList(
    data: $OpenApiTs['/api/admin/organizations/{oid}/invitations']['get']['req'],
  ): CancelablePromise<$OpenApiTs['/api/admin/organizations/{oid}/invitations']['get']['res'][200]> {
    const { oid } = data;
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/admin/organizations/{oid}/invitations',
      path: {
        oid,
      },
    });
  }

  /**
   * Get organization users list
   * @returns any
   * @throws ApiError
   */
  public static getOrganizationUsersList(
    data: $OpenApiTs['/api/admin/organizations/{oid}/users']['get']['req'],
  ): CancelablePromise<$OpenApiTs['/api/admin/organizations/{oid}/users']['get']['res'][200]> {
    const { oid, pageNo, pageSize, orderBy, orderType, search } = data;
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/admin/organizations/{oid}/users',
      path: {
        oid,
      },
      query: {
        pageNo,
        pageSize,
        orderBy,
        orderType,
        search,
      },
    });
  }

  /**
   * Get user details
   * @returns any
   * @throws ApiError
   */
  public static getUserDetails(
    data: $OpenApiTs['/api/admin/users/{userId}']['get']['req'],
  ): CancelablePromise<$OpenApiTs['/api/admin/users/{userId}']['get']['res'][200]> {
    const { userId } = data;
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/admin/users/{userId}',
      path: {
        userId,
      },
    });
  }

  /**
   * Get all users list
   * @returns any
   * @throws ApiError
   */
  public static getAllUsers(
    data: $OpenApiTs['/api/admin/users']['get']['req'],
  ): CancelablePromise<$OpenApiTs['/api/admin/users']['get']['res'][200]> {
    const { pageNo, pageSize, orderBy, orderType, search } = data;
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/admin/users',
      query: {
        pageNo,
        pageSize,
        orderBy,
        orderType,
        search,
      },
    });
  }

  /**
   * Get all admins list
   * @returns any
   * @throws ApiError
   */
  public static getAdmins(
    data: $OpenApiTs['/api/admin/admins']['get']['req'],
  ): CancelablePromise<$OpenApiTs['/api/admin/admins']['get']['res'][200]> {
    const { pageNo, pageSize, orderBy, orderType, search } = data;
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/admin/admins',
      query: {
        pageNo,
        pageSize,
        orderBy,
        orderType,
        search,
      },
    });
  }

  /**
   * Update user role
   * @returns any
   * @throws ApiError
   */
  public static toggleAdminRole(
    data: $OpenApiTs['/api/admin/users/{uid}/admin-role']['put']['req'],
  ): CancelablePromise<$OpenApiTs['/api/admin/users/{uid}/admin-role']['put']['res'][200]> {
    const { uid, requestBody } = data;
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/api/admin/users/{uid}/admin-role',
      path: {
        uid,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * Set user disabled state
   * @returns any
   * @throws ApiError
   */
  public static setUserDisabled(
    data: $OpenApiTs['/api/admin/users/{uid}/disabled']['put']['req'],
  ): CancelablePromise<$OpenApiTs['/api/admin/users/{uid}/disabled']['put']['res'][200]> {
    const { uid, requestBody } = data;
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/api/admin/users/{uid}/disabled',
      path: {
        uid,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * Create new AS One plan
   * @returns any
   * @throws ApiError
   */
  public static createNewAsOnePlan(
    data: $OpenApiTs['/api/admin/as-one-plan']['put']['req'],
  ): CancelablePromise<$OpenApiTs['/api/admin/as-one-plan']['put']['res'][200]> {
    const { requestBody } = data;
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/api/admin/as-one-plan',
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * Edit AS One plan
   * @returns any
   * @throws ApiError
   */
  public static editAsOnePlan(
    data: $OpenApiTs['/api/admin/as-one-plan/{id}']['post']['req'],
  ): CancelablePromise<$OpenApiTs['/api/admin/as-one-plan/{id}']['post']['res'][201]> {
    const { id, requestBody } = data;
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/admin/as-one-plan/{id}',
      path: {
        id,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * Get jobs report
   * @returns any
   * @throws ApiError
   */
  public static getJobsReport(
    data: $OpenApiTs['/api/admin/jobs-report']['get']['req'],
  ): CancelablePromise<$OpenApiTs['/api/admin/jobs-report']['get']['res'][200]> {
    const { pageNo, pageSize, orderBy, orderType, statuses, search, from, to, asOne } = data;
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/admin/jobs-report',
      query: {
        pageNo,
        pageSize,
        orderBy,
        orderType,
        statuses,
        search,
        from,
        to,
        asOne,
      },
    });
  }

  /**
   * Get job by ID
   * @returns any
   * @throws ApiError
   */
  public static getJobById(
    data: $OpenApiTs['/api/admin/job/{id}']['get']['req'],
  ): CancelablePromise<$OpenApiTs['/api/admin/job/{id}']['get']['res'][200]> {
    const { id } = data;
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/admin/job/{id}',
      path: {
        id,
      },
    });
  }

  /**
   * Get job assignee history
   * @returns any
   * @throws ApiError
   */
  public static getJobAssigneeHistory(
    data: $OpenApiTs['/api/admin/jobs/{id}/assignee']['get']['req'],
  ): CancelablePromise<$OpenApiTs['/api/admin/jobs/{id}/assignee']['get']['res'][200]> {
    const { id } = data;
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/admin/jobs/{id}/assignee',
      path: {
        id,
      },
    });
  }

  /**
   * Get admin settings
   * @returns getSettingsResponse
   * @throws ApiError
   */
  public static getSettings(): CancelablePromise<$OpenApiTs['/api/admin/settings']['get']['res'][200]> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/admin/settings',
    });
  }

  /**
   * Update admin setting
   * @returns successResponse
   * @throws ApiError
   */
  public static updateSetting(
    data: $OpenApiTs['/api/admin/settings/{name}']['post']['req'],
  ): CancelablePromise<$OpenApiTs['/api/admin/settings/{name}']['post']['res'][200]> {
    const { name, requestBody } = data;
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/admin/settings/{name}',
      path: {
        name,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * Resubmit job
   * @returns any
   * @throws ApiError
   */
  public static resubmitJob(
    data: $OpenApiTs['/api/admin/jobs/{id}/resubmit-by-admin']['post']['req'],
  ): CancelablePromise<$OpenApiTs['/api/admin/jobs/{id}/resubmit-by-admin']['post']['res'][201]> {
    const { id, chosenTranscriptionModel, forceRetranscribe, priority, dolbyDiagnosisEnabled, advancedPipeline } = data;
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/admin/jobs/{id}/resubmit-by-admin',
      path: {
        id,
      },
      query: {
        chosenTranscriptionModel,
        forceRetranscribe,
        priority,
        dolbyDiagnosisEnabled,
        advancedPipeline,
      },
    });
  }

  /**
   * Creating bulk of draft job (e2e)
   * @returns any
   * @throws ApiError
   */
  public static createBulkJobs(
    data: $OpenApiTs['/api/admin/{wsId}/jobs/create-bulk-and-submit']['post']['req'],
  ): CancelablePromise<$OpenApiTs['/api/admin/{wsId}/jobs/create-bulk-and-submit']['post']['res'][201]> {
    const { wsId } = data;
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/admin/{wsId}/jobs/create-bulk-and-submit',
      path: {
        wsId,
      },
    });
  }

  /**
   * Get bulk of job statuses (e2e)
   * @returns any
   * @throws ApiError
   */
  public static getBulkJobsStatuses(
    data: $OpenApiTs['/api/admin/jobs/statuses']['post']['req'],
  ): CancelablePromise<$OpenApiTs['/api/admin/jobs/statuses']['post']['res'][201]> {
    const { requestBody } = data;
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/admin/jobs/statuses',
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * Get bulk of job pipeline statuses (e2e)
   * @returns any
   * @throws ApiError
   */
  public static getBulkJobsPipelineStatuses(
    data: $OpenApiTs['/api/admin/jobs/pipeline-statuses']['post']['req'],
  ): CancelablePromise<$OpenApiTs['/api/admin/jobs/pipeline-statuses']['post']['res'][201]> {
    const { requestBody } = data;
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/admin/jobs/pipeline-statuses',
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * List job transactions
   * @returns any
   * @throws ApiError
   */
  public static getJobTransactions(
    data: $OpenApiTs['/api/admin/jobs/{id}/transactions']['get']['req'],
  ): CancelablePromise<$OpenApiTs['/api/admin/jobs/{id}/transactions']['get']['res'][200]> {
    const { id } = data;
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/admin/jobs/{id}/transactions',
      path: {
        id,
      },
    });
  }

  /**
   * Refund job
   * @returns any
   * @throws ApiError
   */
  public static refundJob(
    data: $OpenApiTs['/api/admin/jobs/{id}/refund']['post']['req'],
  ): CancelablePromise<$OpenApiTs['/api/admin/jobs/{id}/refund']['post']['res'][201]> {
    const { id, requestBody } = data;
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/admin/jobs/{id}/refund',
      path: {
        id,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * Confirm user after registration
   * @returns any
   * @throws ApiError
   */
  public static confirmUser(
    data: $OpenApiTs['/api/admin/users/{userId}/confirm']['post']['req'],
  ): CancelablePromise<$OpenApiTs['/api/admin/users/{userId}/confirm']['post']['res'][201]> {
    const { userId } = data;
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/admin/users/{userId}/confirm',
      path: {
        userId,
      },
    });
  }

  /**
   * Verify user email after registration
   * @returns any
   * @throws ApiError
   */
  public static verifyUserEmail(
    data: $OpenApiTs['/api/admin/users/{userId}/verify-email']['post']['req'],
  ): CancelablePromise<$OpenApiTs['/api/admin/users/{userId}/verify-email']['post']['res'][201]> {
    const { userId } = data;
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/admin/users/{userId}/verify-email',
      path: {
        userId,
      },
    });
  }

  /**
   * Get Job Utterances
   * @returns GetJobUtterancesResponseDto
   * @throws ApiError
   */
  public static getJobUtterances(
    data: $OpenApiTs['/api/admin/jobs/{id}/utterances']['get']['req'],
  ): CancelablePromise<$OpenApiTs['/api/admin/jobs/{id}/utterances']['get']['res'][200]> {
    const { id, transcript } = data;
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/admin/jobs/{id}/utterances',
      path: {
        id,
      },
      query: {
        transcript,
      },
    });
  }

  /**
   * Get Job Utterances
   * @returns GetEnhancementsDto
   * @throws ApiError
   */
  public static getJobEnhancements(
    data: $OpenApiTs['/api/admin/jobs/{id}/enhancements']['get']['req'],
  ): CancelablePromise<$OpenApiTs['/api/admin/jobs/{id}/enhancements']['get']['res'][200]> {
    const { id } = data;
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/admin/jobs/{id}/enhancements',
      path: {
        id,
      },
    });
  }

  /**
   * Notify all online users about new version
   * @returns any
   * @throws ApiError
   */
  public static notifyAboutNewVersion(): CancelablePromise<
    $OpenApiTs['/api/admin/new-version-notification']['post']['res'][201]
  > {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/admin/new-version-notification',
    });
  }

  /**
   * Trigger job event
   * @returns any
   * @throws ApiError
   */
  public static triggerJob(
    data: $OpenApiTs['/api/admin/jobs/{id}/trigger']['post']['req'],
  ): CancelablePromise<$OpenApiTs['/api/admin/jobs/{id}/trigger']['post']['res'][201]> {
    const { id } = data;
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/admin/jobs/{id}/trigger',
      path: {
        id,
      },
    });
  }

  /**
   * Get ASOne Edits
   * @returns any
   * @throws ApiError
   */
  public static getAsOneEdits(
    data: $OpenApiTs['/api/admin/jobs/{id}/asone-edits']['get']['req'],
  ): CancelablePromise<$OpenApiTs['/api/admin/jobs/{id}/asone-edits']['get']['res'][200]> {
    const { id } = data;
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/admin/jobs/{id}/asone-edits',
      path: {
        id,
      },
    });
  }

  /**
   * Create SMS OTP Country Rule
   * @returns any
   * @throws ApiError
   */
  public static create(
    data: $OpenApiTs['/api/admin/sms-countries']['post']['req'],
  ): CancelablePromise<$OpenApiTs['/api/admin/sms-countries']['post']['res'][201]> {
    const { requestBody } = data;
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/admin/sms-countries',
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * Get all SMS OTP Country Rule
   * @returns any
   * @throws ApiError
   */
  public static findAll(): CancelablePromise<$OpenApiTs['/api/admin/sms-countries']['get']['res'][200]> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/admin/sms-countries',
    });
  }

  /**
   * Delete empty SMS OTP Country Rule
   * @returns any
   * @throws ApiError
   */
  public static removeEmpty(): CancelablePromise<$OpenApiTs['/api/admin/sms-countries']['delete']['res'][200]> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/api/admin/sms-countries',
    });
  }

  /**
   * Get SMS OTP Country Rule
   * @returns any
   * @throws ApiError
   */
  public static findOne(
    data: $OpenApiTs['/api/admin/sms-countries/{code}']['get']['req'],
  ): CancelablePromise<$OpenApiTs['/api/admin/sms-countries/{code}']['get']['res'][200]> {
    const { code } = data;
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/admin/sms-countries/{code}',
      path: {
        code,
      },
    });
  }

  /**
   * Update SMS OTP Country Rule
   * @returns any
   * @throws ApiError
   */
  public static update(
    data: $OpenApiTs['/api/admin/sms-countries/{code}']['patch']['req'],
  ): CancelablePromise<$OpenApiTs['/api/admin/sms-countries/{code}']['patch']['res'][200]> {
    const { code, requestBody } = data;
    return __request(OpenAPI, {
      method: 'PATCH',
      url: '/api/admin/sms-countries/{code}',
      path: {
        code,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * Delete SMS OTP Country Rule
   * @returns any
   * @throws ApiError
   */
  public static remove(
    data: $OpenApiTs['/api/admin/sms-countries/{code}']['delete']['req'],
  ): CancelablePromise<$OpenApiTs['/api/admin/sms-countries/{code}']['delete']['res'][200]> {
    const { code } = data;
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/api/admin/sms-countries/{code}',
      path: {
        code,
      },
    });
  }
}

export class RecordingSessionService {
  /**
   * View all active recording sessions for the current user
   * @returns any
   * @throws ApiError
   */
  public static findAllForUser(): CancelablePromise<$OpenApiTs['/api/recording-session']['get']['res'][200]> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/recording-session',
    });
  }

  /**
   * Create a new draft job and assign the current user
   * @returns any
   * @throws ApiError
   */
  public static create(
    data: $OpenApiTs['/api/recording-session/create']['post']['req'],
  ): CancelablePromise<$OpenApiTs['/api/recording-session/create']['post']['res'][201]> {
    const { requestBody } = data;
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/recording-session/create',
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * Find one recording session if active
   * @returns any
   * @throws ApiError
   */
  public static findOne(
    data: $OpenApiTs['/api/recording-session/{id}']['get']['req'],
  ): CancelablePromise<$OpenApiTs['/api/recording-session/{id}']['get']['res'][200]> {
    const { id } = data;
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/recording-session/{id}',
      path: {
        id,
      },
    });
  }

  /**
   * @returns any
   * @throws ApiError
   */
  public static submitPreprocessing(
    data: $OpenApiTs['/api/recording-session/{id}']['patch']['req'],
  ): CancelablePromise<$OpenApiTs['/api/recording-session/{id}']['patch']['res'][200]> {
    const { id } = data;
    return __request(OpenAPI, {
      method: 'PATCH',
      url: '/api/recording-session/{id}',
      path: {
        id,
      },
    });
  }

  /**
   * Find one recording session if active
   * @returns any
   * @throws ApiError
   */
  public static allowedToStartSession(
    data: $OpenApiTs['/api/recording-session/{id}/check']['get']['req'],
  ): CancelablePromise<$OpenApiTs['/api/recording-session/{id}/check']['get']['res'][200]> {
    const { id } = data;
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/recording-session/{id}/check',
      path: {
        id,
      },
    });
  }

  /**
   * Check if user can start recording session
   * @returns any
   * @throws ApiError
   */
  public static checkRecordingSession(
    data: $OpenApiTs['/api/recording-session/check-allowance-to-create-for-organization/{oid}']['get']['req'],
  ): CancelablePromise<
    $OpenApiTs['/api/recording-session/check-allowance-to-create-for-organization/{oid}']['get']['res'][200]
  > {
    const { oid } = data;
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/recording-session/check-allowance-to-create-for-organization/{oid}',
      path: {
        oid,
      },
    });
  }

  /**
   * Generate a signed upload for a file
   * @returns any
   * @throws ApiError
   */
  public static upload(
    data: $OpenApiTs['/api/recording-session/{id}/upload-params']['get']['req'],
  ): CancelablePromise<$OpenApiTs['/api/recording-session/{id}/upload-params']['get']['res'][200]> {
    const { id, file, type } = data;
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/recording-session/{id}/upload-params',
      path: {
        id,
      },
      query: {
        file,
        type,
      },
    });
  }

  /**
   * Update job transcriptUnlockType
   * @returns any
   * @throws ApiError
   */
  public static updateJobTranscriptUnlockTypeAsOne(
    data: $OpenApiTs['/api/recording-session/{id}/transcript-unlock-type']['post']['req'],
  ): CancelablePromise<$OpenApiTs['/api/recording-session/{id}/transcript-unlock-type']['post']['res'][201]> {
    const { id, requestBody } = data;
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/recording-session/{id}/transcript-unlock-type',
      path: {
        id,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * Add billing checkpoint to recording session
   * @returns any
   * @throws ApiError
   */
  public static addBillingCheckpoint(
    data: $OpenApiTs['/api/recording-session/{id}/billing-checkpoint']['post']['req'],
  ): CancelablePromise<$OpenApiTs['/api/recording-session/{id}/billing-checkpoint']['post']['res'][201]> {
    const { id, requestBody } = data;
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/recording-session/{id}/billing-checkpoint',
      path: {
        id,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * Get recording session files names with sizes
   * @returns any
   * @throws ApiError
   */
  public static getRecordingSessionFilesNamesWithSize(
    data: $OpenApiTs['/api/recording-session/{id}/files']['get']['req'],
  ): CancelablePromise<$OpenApiTs['/api/recording-session/{id}/files']['get']['res'][200]> {
    const { id } = data;
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/recording-session/{id}/files',
      path: {
        id,
      },
    });
  }
}

export class DashboardService {
  /**
   * Get dashboard info
   * @returns any
   * @throws ApiError
   */
  public static getDashboardInfo(
    data: $OpenApiTs['/api/dashboard/{oid}']['get']['req'],
  ): CancelablePromise<$OpenApiTs['/api/dashboard/{oid}']['get']['res'][200]> {
    const { oid } = data;
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/dashboard/{oid}',
      path: {
        oid,
      },
    });
  }

  /**
   * Get scriber dashboard info
   * @returns any
   * @throws ApiError
   */
  public static getScriberDashboardInfo(
    data: $OpenApiTs['/api/dashboard/{oid}/scriber']['get']['req'],
  ): CancelablePromise<$OpenApiTs['/api/dashboard/{oid}/scriber']['get']['res'][200]> {
    const { oid } = data;
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/dashboard/{oid}/scriber',
      path: {
        oid,
      },
    });
  }
}

export class BillingService {
  /**
   * Unlock a job
   * @returns any
   * @throws ApiError
   */
  public static unlockJob(
    data: $OpenApiTs['/api/{wsid}/jobs/{id}/unlock']['patch']['req'],
  ): CancelablePromise<$OpenApiTs['/api/{wsid}/jobs/{id}/unlock']['patch']['res'][200]> {
    const { wsid, id } = data;
    return __request(OpenAPI, {
      method: 'PATCH',
      url: '/api/{wsid}/jobs/{id}/unlock',
      path: {
        wsid,
        id,
      },
    });
  }

  /**
   * @returns any
   * @throws ApiError
   */
  public static getUsage(): CancelablePromise<$OpenApiTs['/api/billing/usage']['get']['res'][200]> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/billing/usage',
    });
  }

  /**
   * Get job pricing
   * @returns any
   * @throws ApiError
   */
  public static calculateJobPricing(
    data: $OpenApiTs['/api/billing/calculate/{jobId}']['get']['req'],
  ): CancelablePromise<$OpenApiTs['/api/billing/calculate/{jobId}']['get']['res'][200]> {
    const { jobId } = data;
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/billing/calculate/{jobId}',
      path: {
        jobId,
      },
    });
  }

  /**
   * Get job unlock pricing
   * @returns any
   * @throws ApiError
   */
  public static calculateJobUnlockPricing(
    data: $OpenApiTs['/api/billing/calculate/{jobId}/unlock']['get']['req'],
  ): CancelablePromise<$OpenApiTs['/api/billing/calculate/{jobId}/unlock']['get']['res'][200]> {
    const { jobId } = data;
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/billing/calculate/{jobId}/unlock',
      path: {
        jobId,
      },
    });
  }
}

export class ReportsService {
  /**
   * Get jobs report
   * @returns any
   * @throws ApiError
   */
  public static getJobsReport(
    data: $OpenApiTs['/api/reports/{wsid}/jobs']['get']['req'],
  ): CancelablePromise<$OpenApiTs['/api/reports/{wsid}/jobs']['get']['res'][200]> {
    const { wsid, pageNo, pageSize, orderBy, orderType, search, jobsFrom, jobsTo } = data;
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/reports/{wsid}/jobs',
      path: {
        wsid,
      },
      query: {
        pageNo,
        pageSize,
        orderBy,
        orderType,
        search,
        jobsFrom,
        jobsTo,
      },
    });
  }

  /**
   * Get user jobs report
   * @returns any
   * @throws ApiError
   */
  public static getUserJobsReport(
    data: $OpenApiTs['/api/reports/{wsid}/jobs/{userId}']['get']['req'],
  ): CancelablePromise<$OpenApiTs['/api/reports/{wsid}/jobs/{userId}']['get']['res'][200]> {
    const { wsid, userId, pageNo, pageSize, orderBy, orderType, search, jobsFrom, jobsTo } = data;
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/reports/{wsid}/jobs/{userId}',
      path: {
        wsid,
        userId,
      },
      query: {
        pageNo,
        pageSize,
        orderBy,
        orderType,
        search,
        jobsFrom,
        jobsTo,
      },
    });
  }
}

export class SupportService {
  /**
   * Send email to sales team
   * @returns any
   * @throws ApiError
   */
  public static sendSalesEmail(
    data: $OpenApiTs['/api/support/sales']['post']['req'],
  ): CancelablePromise<$OpenApiTs['/api/support/sales']['post']['res'][201]> {
    const { requestBody } = data;
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/support/sales',
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * Send email to sales team
   * @returns any
   * @throws ApiError
   */
  public static sendSalesEmailFromLanding(
    data: $OpenApiTs['/api/support/sales-landing']['post']['req'],
  ): CancelablePromise<$OpenApiTs['/api/support/sales-landing']['post']['res'][201]> {
    const { requestBody } = data;
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/support/sales-landing',
      body: requestBody,
      mediaType: 'application/json',
    });
  }
}

export class RsProService {
  /**
   * Check RSPro license status for user
   * @returns CheckRsProLicenseDto
   * @throws ApiError
   */
  public static checkRsProLicense(): CancelablePromise<$OpenApiTs['/api/rspro/license']['get']['res'][200]> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/rspro/license',
    });
  }
}

export class DesktopService {
  /**
   * @returns any
   * @throws ApiError
   */
  public static getJobInfo(
    data: $OpenApiTs['/api/desktop/{jobId}']['get']['req'],
  ): CancelablePromise<$OpenApiTs['/api/desktop/{jobId}']['get']['res'][200]> {
    const { jobId } = data;
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/desktop/{jobId}',
      path: {
        jobId,
      },
    });
  }

  /**
   * @returns any
   * @throws ApiError
   */
  public static getDesktopDownloadLinks(
    data: $OpenApiTs['/api/desktop/download/{jobId}']['get']['req'],
  ): CancelablePromise<$OpenApiTs['/api/desktop/download/{jobId}']['get']['res'][200]> {
    const { jobId } = data;
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/desktop/download/{jobId}',
      path: {
        jobId,
      },
    });
  }

  /**
   * @deprecated
   * @returns any
   * @throws ApiError
   */
  public static getDesktopUploadLinks(
    data: $OpenApiTs['/api/desktop/upload/{jobId}']['get']['req'],
  ): CancelablePromise<$OpenApiTs['/api/desktop/upload/{jobId}']['get']['res'][200]> {
    const { jobId } = data;
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/desktop/upload/{jobId}',
      path: {
        jobId,
      },
    });
  }
}

export class InvitationsService {
  /**
   * Get organization invitation
   * @returns any
   * @throws ApiError
   */
  public static getInvitation(
    data: $OpenApiTs['/api/invitations/{id}']['get']['req'],
  ): CancelablePromise<$OpenApiTs['/api/invitations/{id}']['get']['res'][200]> {
    const { id } = data;
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/invitations/{id}',
      path: {
        id,
      },
    });
  }

  /**
   * Accept organization invitation
   * @returns any
   * @throws ApiError
   */
  public static acceptInvitation(
    data: $OpenApiTs['/api/invitations/{id}/accept']['post']['req'],
  ): CancelablePromise<$OpenApiTs['/api/invitations/{id}/accept']['post']['res'][201]> {
    const { id } = data;
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/invitations/{id}/accept',
      path: {
        id,
      },
    });
  }
}

export class JobSubscriptionsService {
  /**
   * Get all subscriptions
   * @returns GetJobSubscriptionsListDto
   * @throws ApiError
   */
  public static getList(): CancelablePromise<$OpenApiTs['/api/job-subscriptions']['get']['res'][200]> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/job-subscriptions',
    });
  }

  /**
   * Upsert subscription
   * @returns any
   * @throws ApiError
   */
  public static upsert(
    data: $OpenApiTs['/api/job-subscriptions/{jobId}']['post']['req'],
  ): CancelablePromise<$OpenApiTs['/api/job-subscriptions/{jobId}']['post']['res'][201]> {
    const { jobId, requestBody } = data;
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/job-subscriptions/{jobId}',
      path: {
        jobId,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * Delete subscription
   * @returns any
   * @throws ApiError
   */
  public static delete(
    data: $OpenApiTs['/api/job-subscriptions/{jobId}']['delete']['req'],
  ): CancelablePromise<$OpenApiTs['/api/job-subscriptions/{jobId}']['delete']['res'][200]> {
    const { jobId } = data;
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/api/job-subscriptions/{jobId}',
      path: {
        jobId,
      },
    });
  }
}

export class FeatureFlagsService {
  /**
   * Create new feature flag
   * @returns any
   * @throws ApiError
   */
  public static create(
    data: $OpenApiTs['/api/feature-flags/admin']['post']['req'],
  ): CancelablePromise<$OpenApiTs['/api/feature-flags/admin']['post']['res'][201]> {
    const { requestBody } = data;
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/feature-flags/admin',
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * Find all feature flags
   * @returns any
   * @throws ApiError
   */
  public static findAll(): CancelablePromise<$OpenApiTs['/api/feature-flags/admin']['get']['res'][200]> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/feature-flags/admin',
    });
  }

  /**
   * Update organization feature flag
   * @returns any
   * @throws ApiError
   */
  public static updateOrganizationFeatureFlag(
    data: $OpenApiTs['/api/feature-flags/admin/organization/{oid}']['post']['req'],
  ): CancelablePromise<$OpenApiTs['/api/feature-flags/admin/organization/{oid}']['post']['res'][201]> {
    const { oid, requestBody } = data;
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/feature-flags/admin/organization/{oid}',
      path: {
        oid,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * Find one feature flag
   * @returns any
   * @throws ApiError
   */
  public static findOne(
    data: $OpenApiTs['/api/feature-flags/admin/{id}']['get']['req'],
  ): CancelablePromise<$OpenApiTs['/api/feature-flags/admin/{id}']['get']['res'][200]> {
    const { id } = data;
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/feature-flags/admin/{id}',
      path: {
        id,
      },
    });
  }

  /**
   * Update a feature flag
   * @returns any
   * @throws ApiError
   */
  public static update(
    data: $OpenApiTs['/api/feature-flags/admin/{id}']['patch']['req'],
  ): CancelablePromise<$OpenApiTs['/api/feature-flags/admin/{id}']['patch']['res'][200]> {
    const { id, requestBody } = data;
    return __request(OpenAPI, {
      method: 'PATCH',
      url: '/api/feature-flags/admin/{id}',
      path: {
        id,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * Delete a feature flag
   * @returns any
   * @throws ApiError
   */
  public static remove(
    data: $OpenApiTs['/api/feature-flags/admin/{id}']['delete']['req'],
  ): CancelablePromise<$OpenApiTs['/api/feature-flags/admin/{id}']['delete']['res'][200]> {
    const { id } = data;
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/api/feature-flags/admin/{id}',
      path: {
        id,
      },
    });
  }
}

export class WorkspaceSubscriptionsService {
  /**
   * Get all subscriptions
   * @returns GetWorkspaceSubscriptionsListDto
   * @throws ApiError
   */
  public static getList(): CancelablePromise<$OpenApiTs['/api/workspace-subscriptions']['get']['res'][200]> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/workspace-subscriptions',
    });
  }

  /**
   * Create subscription
   * @returns any
   * @throws ApiError
   */
  public static create(
    data: $OpenApiTs['/api/workspace-subscriptions/{workspaceId}']['post']['req'],
  ): CancelablePromise<$OpenApiTs['/api/workspace-subscriptions/{workspaceId}']['post']['res'][201]> {
    const { workspaceId } = data;
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/workspace-subscriptions/{workspaceId}',
      path: {
        workspaceId,
      },
    });
  }

  /**
   * Delete subscription
   * @returns any
   * @throws ApiError
   */
  public static delete(
    data: $OpenApiTs['/api/workspace-subscriptions/{workspaceId}']['delete']['req'],
  ): CancelablePromise<$OpenApiTs['/api/workspace-subscriptions/{workspaceId}']['delete']['res'][200]> {
    const { workspaceId } = data;
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/api/workspace-subscriptions/{workspaceId}',
      path: {
        workspaceId,
      },
    });
  }
}

export class TeamsService {
  /**
   * Create a new Team
   * @returns any
   * @throws ApiError
   */
  public static create(
    data: $OpenApiTs['/api/teams']['post']['req'],
  ): CancelablePromise<$OpenApiTs['/api/teams']['post']['res'][201]> {
    const { requestBody } = data;
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/teams',
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * List all Teams in an Organization
   * @returns any
   * @throws ApiError
   */
  public static findAll(
    data: $OpenApiTs['/api/teams/organization/{oid}']['get']['req'],
  ): CancelablePromise<$OpenApiTs['/api/teams/organization/{oid}']['get']['res'][200]> {
    const { oid } = data;
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/teams/organization/{oid}',
      path: {
        oid,
      },
    });
  }

  /**
   * Find a team by ID
   * @returns any
   * @throws ApiError
   */
  public static findOne(
    data: $OpenApiTs['/api/teams/{id}']['get']['req'],
  ): CancelablePromise<$OpenApiTs['/api/teams/{id}']['get']['res'][200]> {
    const { id } = data;
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/teams/{id}',
      path: {
        id,
      },
    });
  }

  /**
   * Update a Team
   * @returns any
   * @throws ApiError
   */
  public static update(
    data: $OpenApiTs['/api/teams/{id}']['patch']['req'],
  ): CancelablePromise<$OpenApiTs['/api/teams/{id}']['patch']['res'][200]> {
    const { id, requestBody } = data;
    return __request(OpenAPI, {
      method: 'PATCH',
      url: '/api/teams/{id}',
      path: {
        id,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * Delete Team
   * @returns any
   * @throws ApiError
   */
  public static remove(
    data: $OpenApiTs['/api/teams/{id}']['delete']['req'],
  ): CancelablePromise<$OpenApiTs['/api/teams/{id}']['delete']['res'][200]> {
    const { id } = data;
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/api/teams/{id}',
      path: {
        id,
      },
    });
  }

  /**
   * Find a team by ID
   * @returns any
   * @throws ApiError
   */
  public static adminFindOne(
    data: $OpenApiTs['/api/teams/admin/{id}']['get']['req'],
  ): CancelablePromise<$OpenApiTs['/api/teams/admin/{id}']['get']['res'][200]> {
    const { id } = data;
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/teams/admin/{id}',
      path: {
        id,
      },
    });
  }

  /**
   * List available members within a team
   * @returns any
   * @throws ApiError
   */
  public static findAvailableMembers(
    data: $OpenApiTs['/api/teams/{id}/available-members']['get']['req'],
  ): CancelablePromise<$OpenApiTs['/api/teams/{id}/available-members']['get']['res'][200]> {
    const { id } = data;
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/teams/{id}/available-members',
      path: {
        id,
      },
    });
  }

  /**
   * Find a team by slug
   * @returns any
   * @throws ApiError
   */
  public static findOneBySlug(
    data: $OpenApiTs['/api/teams/{oid}/slug/{slug}']['get']['req'],
  ): CancelablePromise<$OpenApiTs['/api/teams/{oid}/slug/{slug}']['get']['res'][200]> {
    const { oid, slug } = data;
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/teams/{oid}/slug/{slug}',
      path: {
        oid,
        slug,
      },
    });
  }

  /**
   * Check if the given slug is available for the current organization
   * @returns any
   * @throws ApiError
   */
  public static isTeamSlugAvailable(
    data: $OpenApiTs['/api/teams/is-available/{oid}/{id}/{slug}']['get']['req'],
  ): CancelablePromise<$OpenApiTs['/api/teams/is-available/{oid}/{id}/{slug}']['get']['res'][200]> {
    const { oid, id, slug } = data;
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/teams/is-available/{oid}/{id}/{slug}',
      path: {
        oid,
        id,
        slug,
      },
    });
  }

  /**
   * Check if the given slug is available
   * @returns IsSlugAvailableResponse
   * @throws ApiError
   */
  public static isSlugAvailable(
    data: $OpenApiTs['/api/teams/is-available/{oid}/{slug}']['get']['req'],
  ): CancelablePromise<$OpenApiTs['/api/teams/is-available/{oid}/{slug}']['get']['res'][200]> {
    const { oid, slug } = data;
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/teams/is-available/{oid}/{slug}',
      path: {
        oid,
        slug,
      },
    });
  }

  /**
   * Update Team members
   * @returns any
   * @throws ApiError
   */
  public static updateMembers(
    data: $OpenApiTs['/api/teams/{id}/members']['patch']['req'],
  ): CancelablePromise<$OpenApiTs['/api/teams/{id}/members']['patch']['res'][200]> {
    const { id, requestBody } = data;
    return __request(OpenAPI, {
      method: 'PATCH',
      url: '/api/teams/{id}/members',
      path: {
        id,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * Remove team from user
   * @returns any
   * @throws ApiError
   */
  public static removeTeamFromUser(
    data: $OpenApiTs['/api/teams/{oid}/user/{userId}/{id}']['delete']['req'],
  ): CancelablePromise<$OpenApiTs['/api/teams/{oid}/user/{userId}/{id}']['delete']['res'][200]> {
    const { id, userId, oid } = data;
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/api/teams/{oid}/user/{userId}/{id}',
      path: {
        id,
        userId,
        oid,
      },
    });
  }

  /**
   * Remove user from team
   * @returns any
   * @throws ApiError
   */
  public static removeMember(
    data: $OpenApiTs['/api/teams/{id}/member/{memberId}']['delete']['req'],
  ): CancelablePromise<$OpenApiTs['/api/teams/{id}/member/{memberId}']['delete']['res'][200]> {
    const { id, memberId } = data;
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/api/teams/{id}/member/{memberId}',
      path: {
        id,
        memberId,
      },
    });
  }
}

export class PrivateService {
  /**
   * Create a new job
   * @returns any
   * @throws ApiError
   */
  public static createJob(
    data: $OpenApiTs['/api/private/{oid}/{wsid}/job']['post']['req'],
  ): CancelablePromise<$OpenApiTs['/api/private/{oid}/{wsid}/job']['post']['res'][201]> {
    const { oid, wsid, apiKey, requestBody } = data;
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/private/{oid}/{wsid}/job',
      path: {
        oid,
        wsid,
      },
      headers: {
        'api-key': apiKey,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * Get Job details
   * @returns any
   * @throws ApiError
   */
  public static getAdminJobDetails(
    data: $OpenApiTs['/api/private/admin/{jobId}']['get']['req'],
  ): CancelablePromise<$OpenApiTs['/api/private/admin/{jobId}']['get']['res'][200]> {
    const { jobId, apiKey } = data;
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/private/admin/{jobId}',
      path: {
        jobId,
      },
      headers: {
        'api-key': apiKey,
      },
    });
  }

  /**
   * Get Job details
   * @returns any
   * @throws ApiError
   */
  public static getJobDetails(
    data: $OpenApiTs['/api/private/{oid}/{jobId}']['get']['req'],
  ): CancelablePromise<$OpenApiTs['/api/private/{oid}/{jobId}']['get']['res'][200]> {
    const { oid, jobId, apiKey } = data;
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/private/{oid}/{jobId}',
      path: {
        oid,
        jobId,
      },
      headers: {
        'api-key': apiKey,
      },
    });
  }

  /**
   * Get S3 upload params for Job files
   * @returns any
   * @throws ApiError
   */
  public static getUploadParams(
    data: $OpenApiTs['/api/private/{oid}/{jobId}/upload-params']['get']['req'],
  ): CancelablePromise<$OpenApiTs['/api/private/{oid}/{jobId}/upload-params']['get']['res'][200]> {
    const { oid, jobId, file, apiKey } = data;
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/private/{oid}/{jobId}/upload-params',
      path: {
        oid,
        jobId,
      },
      headers: {
        'api-key': apiKey,
      },
      query: {
        file,
      },
    });
  }

  /**
   * Attach S3 uploaded file to Job
   * @returns any
   * @throws ApiError
   */
  public static attachFileToJob(
    data: $OpenApiTs['/api/private/{oid}/{jobId}/file']['post']['req'],
  ): CancelablePromise<$OpenApiTs['/api/private/{oid}/{jobId}/file']['post']['res'][201]> {
    const { oid, jobId, requestBody } = data;
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/private/{oid}/{jobId}/file',
      path: {
        oid,
        jobId,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * Submit Job
   * @returns any
   * @throws ApiError
   */
  public static submitJob(
    data: $OpenApiTs['/api/private/{oid}/{jobId}/submit']['post']['req'],
  ): CancelablePromise<$OpenApiTs['/api/private/{oid}/{jobId}/submit']['post']['res'][201]> {
    const { oid, jobId } = data;
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/private/{oid}/{jobId}/submit',
      path: {
        oid,
        jobId,
      },
    });
  }
}

export class ApiKeysService {
  /**
   * Create a new API key
   * @returns any
   * @throws ApiError
   */
  public static create(
    data: $OpenApiTs['/api/api-keys/{oid}']['post']['req'],
  ): CancelablePromise<$OpenApiTs['/api/api-keys/{oid}']['post']['res'][201]> {
    const { oid, requestBody } = data;
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/api-keys/{oid}',
      path: {
        oid,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * List all API keys in an Organization
   * @returns any
   * @throws ApiError
   */
  public static findAll(
    data: $OpenApiTs['/api/api-keys/{oid}']['get']['req'],
  ): CancelablePromise<$OpenApiTs['/api/api-keys/{oid}']['get']['res'][200]> {
    const { oid } = data;
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/api-keys/{oid}',
      path: {
        oid,
      },
    });
  }

  /**
   * Delete API key
   * @returns any
   * @throws ApiError
   */
  public static remove(
    data: $OpenApiTs['/api/api-keys/{oid}/{id}']['delete']['req'],
  ): CancelablePromise<$OpenApiTs['/api/api-keys/{oid}/{id}']['delete']['res'][200]> {
    const { oid, id } = data;
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/api/api-keys/{oid}/{id}',
      path: {
        oid,
        id,
      },
    });
  }
}

export class SsoProviderService {
  /**
   * Create new SSO Provider
   * @returns any
   * @throws ApiError
   */
  public static create(
    data: $OpenApiTs['/api/sso-providers/admin']['post']['req'],
  ): CancelablePromise<$OpenApiTs['/api/sso-providers/admin']['post']['res'][201]> {
    const { requestBody } = data;
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/sso-providers/admin',
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * Find all SSO Providers
   * @returns any
   * @throws ApiError
   */
  public static findAll(
    data: $OpenApiTs['/api/sso-providers/admin']['get']['req'],
  ): CancelablePromise<$OpenApiTs['/api/sso-providers/admin']['get']['res'][200]> {
    const { pageNo, pageSize, orderBy, orderType, search } = data;
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/sso-providers/admin',
      query: {
        pageNo,
        pageSize,
        orderBy,
        orderType,
        search,
      },
    });
  }

  /**
   * Find one SSO Provider
   * @returns any
   * @throws ApiError
   */
  public static findOne(
    data: $OpenApiTs['/api/sso-providers/admin/{id}']['get']['req'],
  ): CancelablePromise<$OpenApiTs['/api/sso-providers/admin/{id}']['get']['res'][200]> {
    const { id } = data;
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/sso-providers/admin/{id}',
      path: {
        id,
      },
    });
  }

  /**
   * Update a SSO Provider
   * @returns any
   * @throws ApiError
   */
  public static update(
    data: $OpenApiTs['/api/sso-providers/admin/{id}']['patch']['req'],
  ): CancelablePromise<$OpenApiTs['/api/sso-providers/admin/{id}']['patch']['res'][200]> {
    const { id, requestBody } = data;
    return __request(OpenAPI, {
      method: 'PATCH',
      url: '/api/sso-providers/admin/{id}',
      path: {
        id,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * Delete a SSO Provider
   * @returns any
   * @throws ApiError
   */
  public static remove(
    data: $OpenApiTs['/api/sso-providers/admin/{id}']['delete']['req'],
  ): CancelablePromise<$OpenApiTs['/api/sso-providers/admin/{id}']['delete']['res'][200]> {
    const { id } = data;
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/api/sso-providers/admin/{id}',
      path: {
        id,
      },
    });
  }

  /**
   * Check if domain requires SSO
   * @returns any
   * @throws ApiError
   */
  public static checkDomain(
    data: $OpenApiTs['/api/sso-providers/check-domain']['post']['req'],
  ): CancelablePromise<$OpenApiTs['/api/sso-providers/check-domain']['post']['res'][201]> {
    const { requestBody } = data;
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/sso-providers/check-domain',
      body: requestBody,
      mediaType: 'application/json',
    });
  }
}

export class SmsCountriesService {
  /**
   * Create SMS OTP Country Rule
   * @returns any
   * @throws ApiError
   */
  public static create(
    data: $OpenApiTs['/api/admin/sms-countries']['post']['req'],
  ): CancelablePromise<$OpenApiTs['/api/admin/sms-countries']['post']['res'][201]> {
    const { requestBody } = data;
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/admin/sms-countries',
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * Get all SMS OTP Country Rule
   * @returns any
   * @throws ApiError
   */
  public static findAll(): CancelablePromise<$OpenApiTs['/api/admin/sms-countries']['get']['res'][200]> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/admin/sms-countries',
    });
  }

  /**
   * Delete empty SMS OTP Country Rule
   * @returns any
   * @throws ApiError
   */
  public static removeEmpty(): CancelablePromise<$OpenApiTs['/api/admin/sms-countries']['delete']['res'][200]> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/api/admin/sms-countries',
    });
  }

  /**
   * Get SMS OTP Country Rule
   * @returns any
   * @throws ApiError
   */
  public static findOne(
    data: $OpenApiTs['/api/admin/sms-countries/{code}']['get']['req'],
  ): CancelablePromise<$OpenApiTs['/api/admin/sms-countries/{code}']['get']['res'][200]> {
    const { code } = data;
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/admin/sms-countries/{code}',
      path: {
        code,
      },
    });
  }

  /**
   * Update SMS OTP Country Rule
   * @returns any
   * @throws ApiError
   */
  public static update(
    data: $OpenApiTs['/api/admin/sms-countries/{code}']['patch']['req'],
  ): CancelablePromise<$OpenApiTs['/api/admin/sms-countries/{code}']['patch']['res'][200]> {
    const { code, requestBody } = data;
    return __request(OpenAPI, {
      method: 'PATCH',
      url: '/api/admin/sms-countries/{code}',
      path: {
        code,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * Delete SMS OTP Country Rule
   * @returns any
   * @throws ApiError
   */
  public static remove(
    data: $OpenApiTs['/api/admin/sms-countries/{code}']['delete']['req'],
  ): CancelablePromise<$OpenApiTs['/api/admin/sms-countries/{code}']['delete']['res'][200]> {
    const { code } = data;
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/api/admin/sms-countries/{code}',
      path: {
        code,
      },
    });
  }
}

export class SmsWhitelistService {
  /**
   * Create whitelisted mobile number
   * @returns any
   * @throws ApiError
   */
  public static create(
    data: $OpenApiTs['/api/admin/sms-whitelist']['post']['req'],
  ): CancelablePromise<$OpenApiTs['/api/admin/sms-whitelist']['post']['res'][201]> {
    const { requestBody } = data;
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/admin/sms-whitelist',
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * Get all whitelisted mobile number
   * @returns any
   * @throws ApiError
   */
  public static findAll(): CancelablePromise<$OpenApiTs['/api/admin/sms-whitelist']['get']['res'][200]> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/admin/sms-whitelist',
    });
  }

  /**
   * Delete whitelisted mobile number
   * @returns any
   * @throws ApiError
   */
  public static remove(
    data: $OpenApiTs['/api/admin/sms-whitelist/{number}']['delete']['req'],
  ): CancelablePromise<$OpenApiTs['/api/admin/sms-whitelist/{number}']['delete']['res'][200]> {
    const { number } = data;
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/api/admin/sms-whitelist/{number}',
      path: {
        number,
      },
    });
  }
}

export class TransactionCodeService {
  /**
   * Create new Transaction Code
   * @returns any
   * @throws ApiError
   */
  public static create(
    data: $OpenApiTs['/api/transaction-codes']['post']['req'],
  ): CancelablePromise<$OpenApiTs['/api/transaction-codes']['post']['res'][201]> {
    const { requestBody } = data;
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/transaction-codes',
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * Find all Transaction Codes
   * @returns any
   * @throws ApiError
   */
  public static findAll(
    data: $OpenApiTs['/api/transaction-codes']['get']['req'],
  ): CancelablePromise<$OpenApiTs['/api/transaction-codes']['get']['res'][200]> {
    const { pageNo, pageSize, orderBy, orderType, search } = data;
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/transaction-codes',
      query: {
        pageNo,
        pageSize,
        orderBy,
        orderType,
        search,
      },
    });
  }

  /**
   * Find one Transaction Code
   * @returns any
   * @throws ApiError
   */
  public static findOne(
    data: $OpenApiTs['/api/transaction-codes/{code}']['get']['req'],
  ): CancelablePromise<$OpenApiTs['/api/transaction-codes/{code}']['get']['res'][200]> {
    const { code } = data;
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/transaction-codes/{code}',
      path: {
        code,
      },
    });
  }
}

export class WebsocketsService {
  /**
   * Create a websocket session via HTTP request
   * @returns any
   * @throws ApiError
   */
  public static create(): CancelablePromise<$OpenApiTs['/api/websockets/create']['post']['res'][201]> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/websockets/create',
    });
  }

  /**
   * Receive API Gateway websocket responses via the default route
   * @returns any
   * @throws ApiError
   */
  public static default(): CancelablePromise<$OpenApiTs['/api/websockets/default']['post']['res'][201]> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/websockets/default',
    });
  }

  /**
   * Ensure that a valid websocket exists and set the AWS API Gateway connection ID
   * @returns any
   * @throws ApiError
   */
  public static connect(): CancelablePromise<$OpenApiTs['/api/websockets/connect']['post']['res'][201]> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/websockets/connect',
    });
  }

  /**
   * Delete the websocket session on disconnect
   * @returns any
   * @throws ApiError
   */
  public static disconnect(
    data: $OpenApiTs['/api/websockets/disconnect']['post']['req'],
  ): CancelablePromise<$OpenApiTs['/api/websockets/disconnect']['post']['res'][201]> {
    const { xSessionId } = data;
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/websockets/disconnect',
      headers: {
        'x-session-id': xSessionId,
      },
    });
  }
}

export class KeepAliveService {
  /**
   * Check liveness
   * @returns any
   * @throws ApiError
   */
  public static checkLiveness(): CancelablePromise<$OpenApiTs['/api/liveness']['get']['res'][200]> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/liveness',
    });
  }

  /**
   * Check readiness
   * @returns any
   * @throws ApiError
   */
  public static checkReadiness(): CancelablePromise<$OpenApiTs['/api/readiness']['get']['res'][200]> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/readiness',
    });
  }
}

export class VersionsService {
  /**
   * Create a new version for a job
   * @returns Version
   * @returns VersionWithUploadLinks
   * @throws ApiError
   */
  public static create(
    data: $OpenApiTs['/api/jobs/{id}/version']['post']['req'],
  ): CancelablePromise<
    $OpenApiTs['/api/jobs/{id}/version']['post']['res'][200] | $OpenApiTs['/api/jobs/{id}/version']['post']['res'][200]
  > {
    const { id, requestBody } = data;
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/jobs/{id}/version',
      path: {
        id,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * Create initial version for a job from transcript preparer service
   * @returns Version
   * @returns VersionWithUploadLinks
   * @throws ApiError
   */
  public static createInitialVersion(
    data: $OpenApiTs['/api/jobs/{id}/initial-version']['post']['req'],
  ): CancelablePromise<
    | $OpenApiTs['/api/jobs/{id}/initial-version']['post']['res'][200]
    | $OpenApiTs['/api/jobs/{id}/initial-version']['post']['res'][200]
  > {
    const { id } = data;
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/jobs/{id}/initial-version',
      path: {
        id,
      },
    });
  }

  /**
   * Get a list all versions for a job
   * @returns Version
   * @throws ApiError
   */
  public static findAllVersions(): CancelablePromise<$OpenApiTs['/api/admin/versions']['get']['res'][200]> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/admin/versions',
    });
  }

  /**
   * Get a list all versions for a job
   * @returns any
   * @throws ApiError
   */
  public static findAllVersionsForJob(
    data: $OpenApiTs['/api/admin/jobs/{id}/versions']['get']['req'],
  ): CancelablePromise<$OpenApiTs['/api/admin/jobs/{id}/versions']['get']['res'][200]> {
    const { id } = data;
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/admin/jobs/{id}/versions',
      path: {
        id,
      },
    });
  }

  /**
   * Get a list all checkout events for a job
   * @returns any
   * @throws ApiError
   */
  public static findAllCheckoutEventsForJob(
    data: $OpenApiTs['/api/{wsid}/jobs/{id}/checkout-events']['get']['req'],
  ): CancelablePromise<$OpenApiTs['/api/{wsid}/jobs/{id}/checkout-events']['get']['res'][200]> {
    const { wsid, id } = data;
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/{wsid}/jobs/{id}/checkout-events',
      path: {
        wsid,
        id,
      },
    });
  }
}

export class LayoutsService {
  /**
   * @returns GetManyForUserResponseDto
   * @throws ApiError
   */
  public static getUserLayouts(): CancelablePromise<$OpenApiTs['/api/layouts/user/list']['get']['res'][200]> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/layouts/user/list',
    });
  }

  /**
   * @returns GetManyForUserResponseDto
   * @throws ApiError
   */
  public static getOrganizationLayouts(
    data: $OpenApiTs['/api/layouts/{oid}/list']['get']['req'],
  ): CancelablePromise<$OpenApiTs['/api/layouts/{oid}/list']['get']['res'][200]> {
    const { oid } = data;
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/layouts/{oid}/list',
      path: {
        oid,
      },
    });
  }

  /**
   * @returns GetDownloadUrlsForLayoutResponseDto
   * @throws ApiError
   */
  public static getDownloadUrlsForLayout(
    data: $OpenApiTs['/api/layouts/{id}']['get']['req'],
  ): CancelablePromise<$OpenApiTs['/api/layouts/{id}']['get']['res'][200]> {
    const { id } = data;
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/layouts/{id}',
      path: {
        id,
      },
    });
  }

  /**
   * @returns CreateLayoutResponseDto
   * @throws ApiError
   */
  public static createLayout(
    data: $OpenApiTs['/api/layouts/{oid}']['post']['req'],
  ): CancelablePromise<$OpenApiTs['/api/layouts/{oid}']['post']['res'][201]> {
    const { oid, requestBody } = data;
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/layouts/{oid}',
      path: {
        oid,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * @returns ReplaceLayoutResponseDto
   * @throws ApiError
   */
  public static replaceLayout(
    data: $OpenApiTs['/api/layouts/{layoutId}']['put']['req'],
  ): CancelablePromise<$OpenApiTs['/api/layouts/{layoutId}']['put']['res'][200]> {
    const { layoutId, requestBody } = data;
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/api/layouts/{layoutId}',
      path: {
        layoutId,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * @returns DeleteLayoutResponseDto
   * @throws ApiError
   */
  public static deleteLayout(
    data: $OpenApiTs['/api/layouts/{layoutId}']['delete']['req'],
  ): CancelablePromise<$OpenApiTs['/api/layouts/{layoutId}']['delete']['res'][200]> {
    const { layoutId } = data;
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/api/layouts/{layoutId}',
      path: {
        layoutId,
      },
    });
  }
}

export class CanvasService {
  /**
   * Get accounts list
   * @returns any
   * @throws ApiError
   */
  public static getAccounts(): CancelablePromise<$OpenApiTs['/api/canvas/accounts']['get']['res'][200]> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/canvas/accounts',
    });
  }

  /**
   * Get courses list
   * @returns any
   * @throws ApiError
   */
  public static getCourses(): CancelablePromise<$OpenApiTs['/api/canvas/courses']['get']['res'][200]> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/canvas/courses',
    });
  }

  /**
   * Get course info
   * @returns any
   * @throws ApiError
   */
  public static getCourse(
    data: $OpenApiTs['/api/canvas/courses/{courseId}']['get']['req'],
  ): CancelablePromise<$OpenApiTs['/api/canvas/courses/{courseId}']['get']['res'][200]> {
    const { courseId } = data;
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/canvas/courses/{courseId}',
      path: {
        courseId,
      },
    });
  }

  /**
   * Get course students list
   * @returns any
   * @throws ApiError
   */
  public static getCourseStudents(
    data: $OpenApiTs['/api/canvas/courses/{courseId}/students']['get']['req'],
  ): CancelablePromise<$OpenApiTs['/api/canvas/courses/{courseId}/students']['get']['res'][200]> {
    const { courseId } = data;
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/canvas/courses/{courseId}/students',
      path: {
        courseId,
      },
    });
  }

  /**
   * Create course student
   * @returns any
   * @throws ApiError
   */
  public static createCourseStudent(
    data: $OpenApiTs['/api/canvas/courses/{courseId}/students']['post']['req'],
  ): CancelablePromise<$OpenApiTs['/api/canvas/courses/{courseId}/students']['post']['res'][201]> {
    const { courseId, requestBody } = data;
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/canvas/courses/{courseId}/students',
      path: {
        courseId,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }
}

export class PromptsService {
  /**
   * @returns GetAllPromptsResponseDto
   * @throws ApiError
   */
  public static getAll(): CancelablePromise<$OpenApiTs['/api/prompts']['get']['res'][200]> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/prompts',
    });
  }

  /**
   * @returns UpdateTemplateResponseDto
   * @throws ApiError
   */
  public static updatePromptTemplate(
    data: $OpenApiTs['/api/prompts']['patch']['req'],
  ): CancelablePromise<$OpenApiTs['/api/prompts']['patch']['res'][200]> {
    const { requestBody } = data;
    return __request(OpenAPI, {
      method: 'PATCH',
      url: '/api/prompts',
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * @returns GetPromptResponseDto
   * @throws ApiError
   */
  public static getPrompt(
    data: $OpenApiTs['/api/prompts/{slug}']['get']['req'],
  ): CancelablePromise<$OpenApiTs['/api/prompts/{slug}']['get']['res'][200]> {
    const { slug } = data;
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/prompts/{slug}',
      path: {
        slug,
      },
    });
  }
}
